(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["apple-business-chat"] && !window.DesignMode) return;
  try {
    
class AppleBusinessChat extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.addEventListener();
  }

  appleBusinessChatTrack(type) {
    window.dataLayer.push({
      "event": "uaEvent", 
      "eventCategory": "Apple business chat", 
      "eventAction": "text",
      "eventLabel": type,
      "nonInteraction": true
    });
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event": "ga4Event",
      "event_name": "lp_button",
      "event_parameters": {
        "page_group": "Apple business chat", 
        "position": "text", 
        "button_name": type
      }
    });
  }

  addEventListener() {
    const _this = this;
    $('.apple-business-chat')
     .find('.apple-business-chat-btn')
     .on('click', function (e) {
        e.preventDefault();
        _this.appleBusinessChatTrack('click');
        const href = $(this).data('href');
        window.location.href = href;
     });

     const io = new IntersectionObserver((entries) => {
       entries.forEach(item => {
         if (item.isIntersecting) {
           const el = item.target;
           _this.appleBusinessChatTrack('impression');
         }
       });
     });
     
     const $el =  $('.apple-business-chat');
     io.observe($el?.[0]);
  }
}
customElements.define('apple-business-chat', AppleBusinessChat);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-coupon-expansion"] && !window.DesignMode) return;
  try {
    
  class BlackFridayCouponExpansion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.setTimes();
      this.setProcess();
      this.productBuy();
      this.setPopUp();
    }

    productBuy() {
      const $el = $('.black-friday-coupon-expansion');

      $('.bfpc-item')
        .find('.js-buy-now')
        .on('click', function () {
          const vid = $(this).parents('.bfpc-item').data('v-id');
          const line_items = [
            {
              variant_id: vid,
              quantity: 1,
            },
          ];

          Shopify.theme.bundleBuynow({
            authorization: Shopify.storefront,
            checkout: {
              line_items,
              presentment_currency: Currency.shop_currency,
              is_upstream_button: true,
              page_type: 'product',
              secret: true,
              wallet_name: 'Checkout',
            },
            onSuccess: () => {},
            onError: (err) => $.dialog({ title: err.message, content: err.description, type: 'red' }),
          });

          const $parents = $(this).parents('.bfpc-item');
          const sku = $parents.data('sku');
          const name = $parents.data('name');
          const type = $parents.data('type');
          const variant = $parents.data('variant');
          const price = $parents.data('price');
          const pageHandle = $(".black-friday-coupon-expansion").data("pagehandle");
          window.dataLayer.push({
            event: "eeEvent",
            eventCategory: "EnhancedEcommerce",
            eventAction: "BuyNow",
            eventLabel: sku,
            ecommerce: {
              currencyCode: Currency.shop_currency,
              add: {
                products: [{
                  name: name,
                  id: sku,
                  category: "",
                  categoryName: type,
                  brand: "Eufy",
                  variant: variant,
                  price: price / 100,
                  quantity: 1
                }]
              },
            },
          });
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: "ga4Event",
            event_name: "begin_checkout",
            event_parameters: {
              page_group: "Activity Page_" + pageHandle,
              position: $parents.find(".bfpc-title").text(),
              currency: Currency.shop_currency,
              value: price / 100,
              items: [{
                item_id: sku,
                item_name: name,
                item_brand: "Eufy",
                item_category: type,
                item_variant: variant,
                price: price / 100,
                quantity: 1 
              }],
            },
          });
        });
    }

    setPopUp() {
      const $pop = $('.coupon-expansion-rules').clone();
      $pop.append('<i></i>');
      $('.coupon-expansion-desc span')
        .append($pop)
        .on('click', function () {
          const w = $(window).width();
          const hasCls = $(this).hasClass('actived');
          if (w > 1024) return;
          if (hasCls) {
            $(this).removeClass('actived');
          } else {
            $(this).addClass('actived');
          }
        })
        .hover(
          function () {
            const w = $(window).width();
            if (w < 1024) return;
            $(this).addClass('actived');
          },
          function () {
            const w = $(window).width();
            if (w < 1024) return;
            $(this).removeClass('actived');
          }
        );
    }

    setProcess() {
      $('.bfpc-item').each(function (index) {
        const process = $(this).data('process');
        let flag = 0;
        let arr = [];
        $(this)
          .find('.bfpc-process-num')
          .each(function (idx) {
            const txt = $(this).text();
            const couponPrice = $(this).siblings('.bfpc-process-price').text();
            const wasPrice = $('.bfpc-js-was-price').eq(index).text();
            const couponNum = parseFloat(couponPrice.replace(/[^0-9-.]/g, ''));
            const wasNum = parseFloat(wasPrice.replace(/[^0-9-.]/g, ''));
            const nowNum = wasNum - couponNum;
            arr.push(+txt);
            if (process >= +txt) {
              $(this).parent().addClass('actived');
              flag = idx;

              $('.bfpc-pay')
                .eq(index)
                .each(function () {
                  const price = $(this).data('price');
                  $(this).find('.or').text(price);
                  $(this).find('.now').text(couponPrice);
                });

              $('.bfpc-js-now-price').eq(index).text(couponPrice);
            }
          });

        $(this)
          .find('.bfpc-process-bar-inner')
          .each(function (idx) {
            if (flag > idx) {
              $(this).css('width', '100%');
            } else if (flag === idx) {
              const isMax = flag + 1 >= arr.length;
              const gap = isMax ? arr[flag] - arr[flag - 1] : arr[flag + 1] - arr[flag];
              const begin = isMax ? arr[flag - 1] : arr[flag];
              const value = ((process - begin) / gap) * 100;
              $(this)
                .css('width', value + '%')
                .find('.bfpc-process-bar-point')
                .show()
                .find('.bfpc-process-bar-num')
                // .text(value > 12 && value < 88 ? process : '');
                .text(process);
            }
          });
      });
    }

    setTimes() {
      const _this = this;
      const $el = $('.black-friday-coupon-expansion');

      document.addEventListener('serverTimeUpdate', function (e) {
        $('.bfpc-item').each(function () {
          const ends = $(this).data('ends');
          if (!ends) return;

          const start = Shopify.serverTime || new Date();
          const end = ends.replace(/\//gi, '-');

          Shopify.theme.setContDown(
            start,
            end,
            ({ days, hours, minutes, seconds }) => {
              $(this).find('.js-deals-end').text(`${hours}:${minutes}:${seconds}`).parent().show();
            },
            () => {
              $(this).find('.js-deals-end').text(`00:00:00`).parent().hide();
            }
          );
        });
      });
    }
  }

  customElements.define('black-friday-coupon-expansion', BlackFridayCouponExpansion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-discount-group"] && !window.DesignMode) return;
  try {
    
  class BlackFridayDisountGroup extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.setTimes();
      this.productAdd2Cart();
      this.productBuy();
      this.setPopUp();
      this.getDiscount();
    }

    productAdd2Cart() {
      const _this = this;
      $('.discount-group-item')
        .find('.js-add2cart')
        .on('click', function () {
          const $parents = $(this).parents('.discount-group-item');
          const vid = $parents.data('v-id');
          const freeGift = [];
          $parents.find('.js-free-gift-item').each(function () {
            const vid = $(this).data('v-id');
            const quantity = $(this).data('count');
            freeGift.push({
              id: vid,
              quantity,
            });
          });

          const line_items = [
            {
              id: vid,
              quantity: 1,
            },
            ...freeGift,
          ];

          Shopify.theme.addItemsToCart(line_items, {
            onError: (err) => $.dialog({ title: err.message, content: err.description, type: 'red' }),
          });
          _this.ctaEventTrack($parents, 'add_to_cart');
        });
    }

    ctaEventTrack($parents, ctaType) {
      const sku = $parents.data('sku');
      const price = $parents.data('price') / 100;
      const salePrice = $parents.find('.now-price').data('price') || price;
      const coupon = $parents.data('code') || '';
      const discount = $parents.data('discount') || '';
      const name = $parents.data('name') || '';
      const title = $parents.data('title') || '';
      const pageHandle = $('.black-friday-discount-group').data('pagehandle');
      const position = $('.discount-group-title').text().trim() || '';
      const map = {
        add_to_cart: 'Added Product',
        begin_checkout: 'BuyNow',
      };

      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: ctaType,
        event_parameters: {
          page_group: 'Activity Page_' + pageHandle,
          currency: Currency.shop_currency,
          value: salePrice,
          position: position.trim(),
          coupon,
          // item_list_name: 'bfcm_moreDiscount',
          items: [
            {
              item_name: name,
              item_id: sku,
              item_brand: 'Eufy',
              item_category: '',
              item_variant: title,
              price,
              coupon,
              discount,
              quantity: 1,
            },
          ],
        },
      });

      window.dataLayer.push({
        event: 'eeEvent',
        eventCategory: 'EnhancedEcommerce',
        eventAction: map[ctaType],
        eventLabel: sku,
        nonInteraction: false,
        ecommerce: {
          currencyCode: Currency.shop_currency,
          add: {
            products: [
              {
                name,
                id: sku,
                category: '',
                categoryName: '',
                brand: 'Eufy',
                variant: title,
                price,
                quantity: 1,
              },
            ],
          },
        },
      });
    }

    productBuy() {
      const _this = this;
      $('.discount-group-item')
        .find('.js-buy-now')
        .on('click', function () {
          const $parents = $(this).parents('.discount-group-item');
          const vid = $parents.data('v-id');
          const discount = $parents.data('code');
          const freeGift = [];
          $parents.find('.js-free-gift-item').each(function () {
            const vid = $(this).data('v-id');
            const quantity = $(this).data('count');
            freeGift.push({
              variant_id: vid,
              quantity,
            });
          });
          _this.buyNow(vid, discount, freeGift);
          _this.ctaEventTrack($parents, 'begin_checkout');
        });
    }

    setTimes() {
      const $el = $('.black-friday-discount-group');
      const domain = $el.data('domain');
      const state = $el.data('state');
      const _this = this;

      document.addEventListener('serverTimeUpdate', function (e) {
        $('.discount-group-countdown').each(function () {
          const ends = $(this).data('ends');
          if (!ends) return;

          const start = Shopify.serverTime || new Date();
          const end = ends.replace(/\//gi, '-');
          const copyDays = $(this).data('days');
          const copyHrs = $(this).data('hrs');
          const copyMins = $(this).data('mins');
          const copySec = $(this).data('sec');

          Shopify.theme.setContDown(
            start,
            end,
            ({ days, hours, minutes, seconds }) => {
              $(this).html(`<li>
                          <p>${days}</p>
                          <span>${copyDays}</span>
                        </li>
                        <li>
                          <p>${hours}</p>
                          <span>${copyHrs}</span>
                        </li>
                        <li>
                          <p>${minutes}</p>
                          <span>${copyMins}</span>
                        </li>
                        <li>
                          <p>${seconds}</p>
                          <span>${copySec}</span>
                        </li>`);
            },
            () => {
              _this.getDiscount();
              $(this).hide();
              $('.discount-group-subtitle').hide();
              $('.discount-group-item').find('.js-free-gift-item').show();
              $('.discount-group-item').find('.js-add2cart').hide().siblings('.js-buy-now').show();
            }
          );
        });

        if (+state === 2) {
          _this.getDiscount();
          $('.discount-group-item').find('.js-free-gift-item').show();
          $('.discount-group-item').find('.js-add2cart').hide().siblings('.js-buy-now').show();
        }
      });
    }

    buyNow(vid, discount, extend) {
      const line_items = [
        {
          variant_id: vid,
          quantity: 1,
        },
        ...extend,
      ];

      const checkout = {
        line_items,
        presentment_currency: Currency.shop_currency,
        is_upstream_button: true,
        page_type: 'product',
        secret: true,
        wallet_name: 'Checkout',
      };

      if (discount) {
        checkout.discount = discount;
      }
      Shopify.theme.bundleBuynow({
        authorization: Shopify.storefront,
        checkout,
        onSuccess: () => {},
        onError: (err) => $.dialog({ title: err.message, content: err.description, type: 'red' }),
      });
    }

    setPopUp() {
      const $pop = $('.discount-group-rules').clone();
      $pop.append('<i></i>');
      $('.discount-group-desc span')
        .append($pop)
        .on('click', function () {
          const w = $(window).width();
          const hasCls = $(this).hasClass('actived');
          if (w > 1024) return;
          if (hasCls) {
            $(this).removeClass('actived');
          } else {
            $(this).addClass('actived');
          }
        })
        .hover(
          function () {
            const w = $(window).width();
            if (w < 1024) return;
            $(this).addClass('actived');
          },
          function () {
            const w = $(window).width();
            if (w < 1024) return;
            $(this).removeClass('actived');
          }
        );
    }

    getDiscount() {
      const skus = [];
      $('.discount-group-item').each(function () {
        skus.push($(this).data('sku'));
      });

      const data = {
        skus,
        shopify_domain: Shopify.shop,
      };

      $.ajax({
        type: 'GET',
        url: '/apps/pp/shopifyservices/coupons/by_skus',
        data,
        success(res) {
          if (res) {
            $('.discount-group-item').each(function () {
              const sku = $(this).data('sku');
              const $sale = $(this).find('.js-off-tag');
              const credits_times = $('.discount-group-credits').data('times') || 1;
              if (res[sku]) {
                const { title, value_type, value_style, value, variant_price4wscode } = res[sku][0];
                switch (value_type) {
                  case 'fixed_amount':
                    $sale.text(value_style);
                    break;
                  case 'percentage':
                    $sale.text(Math.abs(parseInt(value)) + '%');
                    break;
                }
                $(this)
                  .find('.discount-group-price .now-price')
                  .text(Shopify.theme.formatPirce(variant_price4wscode))
                  .attr('data-price', variant_price4wscode);
                $(this).attr('data-code', title).find('.bf-deals-tag').show();
                $(this).attr('data-discount', $sale.text());
                $(this)
                  .find('.js-credits-times')
                  .text(Math.ceil(variant_price4wscode * credits_times));
              } else {
                const was_price = $(this).find('.discount-group-price .was-price').text();
                const was_price_val = '' + $(this).find('.discount-group-price .was-price').data('price');
                const format_price = +was_price_val.replaceAll(',', '').replaceAll('.', '') / 100;
                $(this)
                  .find('.discount-group-price .now-price')
                  .text(was_price)
                  .attr('data-price', was_price_val)
                  .siblings('.was-price')
                  .hide();
                $(this)
                  .find('.js-credits-times')
                  .text(Math.ceil(format_price * credits_times));
              }
            });
          }
        },
      });
    }
  }

  customElements.define('black-friday-discount-group', BlackFridayDisountGroup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-group-buy"] && !window.DesignMode) return;
  try {
    
  class BlackFridayGroupBuy extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.setTimes();
      this.productBuy();
      this.productAdd2Cart();
      this.getDiscount();
    }

    productAdd2Cart() {
      $('.bfgb-product-item')
        .find('.js-add2cart')
        .on('click', function () {
          const vid = $(this).parents('.bfgb-product-item').data('v-id');
          const line_items = [
            {
              id: vid,
              quantity: 1,
            },
          ];

          Shopify.theme.addItemsToCart(line_items, {
            onError: (err) => $.dialog({ title: err.message, content: err.description, type: 'red' }),
          });
        });
    }

    productBuy() {
      const _this = this;
      $('.bfgb-product-item')
        .find('.js-ori-buy-now')
        .on('click', function () {
          const vid = $(this).parents('.bfgb-product-item').data('v-id');
          const discount = $(this).parents('.bfgb-product-item').data('code') || '';
          _this.buyNow(vid, discount);
          const coupon = $(this).parents('.bfgb-product-item').data('coupon') || '';
          _this.ctaEventTrack($(this).parents('.bfgb-product-item'), discount, coupon);
        });

      $('.bfgb-product-item')
        .find('.js-group-buy-now')
        .each(function () {
          const $parent = $(this).parents('.bfgb-product-item');
          const coupon = $parent.data('code') || '';
          const discount = $parent.data('discount') || '';
          let off = $(this).data('off');
          if (!off) return;
          off = '' + off;
          const p = $(this).find('b').text();
          const pVal = parseFloat(p.replaceAll(Currency.symbol, '').replaceAll('CA', '').replaceAll(',', '.'));
          const val = parseFloat(off.replaceAll(Currency.symbol, ''));
          const content = $(this).html();
          let price;
          if (off.includes('%')) {
            price = Math.ceil((pVal - (val / 100) * pVal) * 100) / 100;
          } else {
            price = Math.ceil((pVal - val) * 100) / 100;
            off = Shopify.theme.formatPirce(val, Shopify.country.toLowerCase(), Currency.shop_currency, 0);
          }
          $(this)
            .html(content.replaceAll('%off%', `<b>${off}</b>`))
            .find('b')
            .eq(0)
            .text(Shopify.theme.formatPirce(price));
          $parent.find('.bf-deals-tag').show().find('.js-off-tag').text(off).attr('data-loaded', true);
          $parent.attr('data-group-coupon', $parent.find('.js-off-tag').text());
        })
        .on('click', function () {
          const vid = $(this).parents('.bfgb-product-item').data('v-id');
          const discount = $(this).data('code');
          const coupon = $(this).parents('.bfgb-product-item').data('group-coupon') || '';
          _this.buyNow(vid, discount);
          _this.ctaEventTrack($(this).parents('.bfgb-product-item'), discount, coupon);
        });
    }

    buyNow(vid, discount) {
      const line_items = [
        {
          variant_id: vid,
          quantity: 1,
        },
      ];

      const checkout = {
        line_items,
        presentment_currency: Currency.shop_currency,
        is_upstream_button: true,
        page_type: 'product',
        secret: true,
        wallet_name: 'Checkout',
      };

      if (discount) {
        checkout.discount = discount;
      }
      Shopify.theme.bundleBuynow({
        authorization: Shopify.storefront,
        checkout,
        onSuccess: () => {},
        onError: (err) => $.dialog({ title: err.message, content: err.description, type: 'red' }),
      });
    }

    setTimes() {
      const $el = $('.black-friday-group-buy');
      const domain = $el.data('domain');

      document.addEventListener('serverTimeUpdate', function (e) {
        $('.bfgb-product-item').each(function () {
          const ends = $(this).data('ends');
          if (!ends) return;

          const start = Shopify.serverTime || new Date();
          const end = ends.replace(/\//gi, '-');

          Shopify.theme.setContDown(
            start,
            end,
            ({ days, hours, minutes, seconds }) => {
              $(this).find('.js-deals-end').text(`${hours}:${minutes}:${seconds}`).parent().show();
            },
            () => {
              $(this).find('.js-deals-end').text(`00:00:00`).parent().hide();
            }
          );
        });
      });
    }

    getDiscount() {
      const skus = [];

      $('.bfgb-product-item').each(function () {
        skus.push($(this).data('sku'));
      });

      const data = {
        skus,
        shopify_domain: Shopify.shop,
      };

      $.ajax({
        type: 'GET',
        url: '/apps/pp/shopifyservices/coupons/by_skus',
        data,
        success(res) {
          if (res) {
            $('.bfgb-product-item').each(function () {
              const sku = $(this).data('sku');
              const $groupBuy = $(this).find('.js-group-buy-now');
              const $sale = $(this).find('.js-off-tag');
              const $btn = $(this).find('.js-ori-buy-now');
              const loaded = $sale.data('loaded');
              if (res[sku]) {
                const { title, value_type, value_style, value, variant_price4wscode } = res[sku][0];
                if (!loaded) {
                  switch (value_type) {
                    case 'fixed_amount':
                      $sale.text(value_style);
                      break;
                    case 'percentage':
                      $sale.text(Math.abs(parseInt(value)) + '%');
                      break;
                  }
                }
                $btn.find('b').text(Shopify.theme.formatPirce(variant_price4wscode));
                $(this).attr('data-code', title).find('.bf-deals-tag').show();
                $(this).attr('data-coupon', $sale.text());
              }
            });
          }
        },
      });
    }

    ctaEventTrack($parents, coupon, discount) {
      const handle = $parents.data('handle');
      const sku = $parents.data('sku');
      const price = $parents.data('price');
      const pageHandle = $('.black-friday-group-buy').data('pagehandle');
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'begin_checkout',
        event_parameters: {
          page_group: 'Activity Page_' + pageHandle,
          currency: Currency.shop_currency,
          value: price / 100,
          coupon: coupon,
          item_list_name: 'bfcm_group',
          items: [
            {
              item_id: sku,
              item_brand: 'Eufy',
              item_category: '',
              item_variant: '',
              price: price / 100,
              coupon: coupon,
              discount: discount,
              quantity: 1,
            },
          ],
        },
      });
    }
  }

  customElements.define('black-friday-group-buy', BlackFridayGroupBuy);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-lightning"] && !window.DesignMode) return;
  try {
    
  class BlackFridayLightning extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.productAdd2Cart();
      this.productBuy();
      this.getSalesByVariantId();
      this.getDiscount();
    }

    productAdd2Cart() {
      const _this = this;
      $('.nightning-deals-item')
        .find('.js-add2cart')
        .on('click', function () {
          const vid = $(this).parents('.nightning-deals-item').data('v-id');
          const line_items = [
            {
              id: vid,
              quantity: 1,
            },
          ];

          Shopify.theme.addItemsToCart(line_items, {
            onError: (err) => $.dialog({ title: err.message, content: err.description, type: 'red' }),
          });
          const $parents = $(this).parents('.nightning-deals-item');
          _this.ctaEventTrack($parents, 'add_to_cart');
        });
    }

    productBuy() {
      const _this = this;
      $('.nightning-deals-item')
        .find('.js-ori-buy-now')
        .on('click', function () {
          const $parents = $(this).parents('.nightning-deals-item');
          const vid = $parents.data('v-id');
          const discount = $parents.data('code');
          _this.buyNow(vid, discount);
          _this.ctaEventTrack($parents, 'begin_checkout');
        });
    }

    getSalesByVariantId() {
      const starts_at = $('.nightning-deals-product').data('start-time');
      const variant_ids = [];
      $('.nightning-deals-item').each(function () {
        variant_ids.push($(this).data('v-id'));
      });
      const data = {
        variant_ids: variant_ids,
        shopify_domain: Shopify.shop,
        starts_at,
      };
      $.ajax({
        type: 'GET',
        url: '/apps/pp/rainbowbridge/panic-buy/common/sales',
        data,
        success(res) {
          if (res.code === 200) {
            $('.nightning-deals-item').each(function () {
              const variant_id = $(this).data('v-id');
              const inventory_quantity = Number($(this).data('inventory-quantity'));
              const virtual_quantity = Number($(this).data('virtual-quantity'));
              if (inventory_quantity <= 0) {
                // 实际库存为0
                $(this).find('.inventory-value').text('0');
                return;
              }
              for (let index = 0; index < res.data.length; index++) {
                const variantData = res.data[index];
                const { total_sales_quantity } = variantData;
                if (variantData.variant_id == variant_id) {
                  // 实际库存大于0
                  if (total_sales_quantity <= 0) {
                    // 销量为0
                    $(this).find('.inventory-value').text(virtual_quantity);
                  } else {
                    // 销量不为0
                    if (total_sales_quantity >= virtual_quantity) {
                      const delivery = total_sales_quantity % virtual_quantity;
                      $(this)
                        .find('.inventory-value')
                        .text(virtual_quantity - delivery);
                      // 销量大于虚拟库存
                    } else {
                      // 销量小于虚拟库存
                      $(this)
                        .find('.inventory-value')
                        .text(virtual_quantity - total_sales_quantity);
                    }
                  }
                  break;
                }
              }
            });
          }
        },
      });
    }

    buyNow(vid, discount) {
      const line_items = [
        {
          variant_id: vid,
          quantity: 1,
        },
      ];

      const checkout = {
        line_items,
        presentment_currency: Currency.shop_currency,
        is_upstream_button: true,
        page_type: 'product',
        secret: true,
        wallet_name: 'Checkout',
      };

      if (discount) {
        checkout.discount = discount;
      }
      Shopify.theme.bundleBuynow({
        authorization: Shopify.storefront,
        checkout,
        onSuccess: () => {},
        onError: (err) => $.dialog({ title: err.message, content: err.description, type: 'red' }),
      });
    }

    getDiscount() {
      const skus = [];

      $('.nightning-deals-item').each(function () {
        skus.push($(this).data('sku'));
      });

      const data = {
        skus,
        shopify_domain: Shopify.shop,
      };

      $.ajax({
        type: 'GET',
        url: '/apps/pp/shopifyservices/coupons/by_skus',
        data,
        success(res) {
          if (res) {
            $('.nightning-deals-item').each(function () {
              const sku = $(this).data('sku');
              const $sale = $(this).find('.js-off-tag');
              if (res[sku]) {
                const { title, value_type, value_style, value, variant_price4wscode, variant_price } = res[sku][0];
                switch (value_type) {
                  case 'fixed_amount':
                    const country = Shopify.country.toLowerCase() || 'uk';
                    let val = country === 'ca' ? `CA${value_style}` : value_style;
                    $sale.text(val);
                    break;
                  case 'percentage':
                    $sale.text(Math.abs(parseInt(+value)) + '%');
                    break;
                }

                $(this)
                  .find('.cur-price')
                  .text(Shopify.theme.formatPirce(variant_price4wscode))
                  .attr('data-price', variant_price4wscode);
                $(this)
                  .find('.was-price')
                  .text(Shopify.theme.formatPirce(variant_price))
                  .attr('data-price', variant_price);
                $(this).attr('data-code', title).find('.bf-deals-tag').show();
                $(this).attr('data-discount', $sale.text());
              }
            });
          }
        },
      });
    }

    ctaEventTrack($parents, ctaType) {
      const handle = $parents.data('handle');
      const sku = $parents.data('sku');
      const price = $parents.data('price') / 100;
      const salePrice = $parents.find('.cur-price').data('price');
      const coupon = $parents.data('code') || '';
      const discount = $parents.data('discount') || '';
      const pageHandle = $('.lightning-deals-section').data('pagehandle');
      const position = $('.lightning-deals-title').text().trim() || '';
      const name = $parents.data('name') || '';
      const title = $parents.data('title') || '';
      const map = {
        add_to_cart: 'Added Product',
        begin_checkout: 'BuyNow',
      };

      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: ctaType,
        event_parameters: {
          page_group: 'Activity Page_' + pageHandle,
          position,
          currency: Currency.shop_currency,
          value: salePrice,
          coupon: coupon,
          // item_list_name: 'bfcm_lightingDeals',
          items: [
            {
              item_id: sku,
              item_brand: 'Eufy',
              item_name: name,
              item_category: '',
              item_variant: '',
              price,
              coupon: coupon,
              discount: discount,
              quantity: 1,
            },
          ],
        },
      });

      window.dataLayer.push({
        event: 'eeEvent',
        eventCategory: 'EnhancedEcommerce',
        eventAction: map[ctaType],
        eventLabel: sku,
        nonInteraction: false,
        ecommerce: {
          currencyCode: Currency.shop_currency,
          add: {
            products: [
              {
                name,
                id: sku,
                category: '',
                categoryName: '',
                brand: 'Eufy',
                variant: title,
                price,
                quantity: 1,
              },
            ],
          },
        },
      });
    }
  }

  customElements.define('black-friday-lightning', BlackFridayLightning);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-timeline"] && !window.DesignMode) return;
  try {
    
  class BlackFridayTimeline extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const w = $(window).width();

      if (w >= 768 && w < 1024) {
        new Swiper('.bf-timeline-container', {
          slidesPerView: 'auto',
          spaceBetween: 12,
          noSwiping: true,
          scrollbar: {
            el: '.product-swiper-process',
            hide: false,
            draggable: true,
            dragSize: 60,
            snapOnRelease: false,
          },
        });
      }
    }
  }

  customElements.define('black-friday-timeline', BlackFridayTimeline);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-article-list"] && !window.DesignMode) return;
  try {
    
  class BlogPages extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const _this = this;
      const pageSize = window.screen.width > 769 ? +$('.blog-article-list .blog-pages').attr('data-group') : +$('.blog-article-list .blog-pages').attr('data-mob-group');
      const dataSource = [];

      $('.all-article-list .article-item').each(function () {
        const idx = $(this).index();
        dataSource.push(idx);
      });

      $('.blog-article-list .blog-pagination-wrap').pagination({
        dataSource,
        pageSize,
        activeClassName: 'actived',
        prevText: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M8.57915 3.08751C8.80695 3.31532 8.80695 3.68466 8.57915 3.91247L5.49162 6.99999L8.57915 10.0875C8.80695 10.3153 8.80695 10.6847 8.57915 10.9125C8.35134 11.1403 7.98199 11.1403 7.75419 10.9125L4.25419 7.41247C4.02638 7.18466 4.02638 6.81532 4.25419 6.58751L7.75419 3.08751C7.98199 2.8597 8.35134 2.85971 8.57915 3.08751Z" fill="#333333"/>
        </svg>`,
        nextText: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M5.42085 10.9125C5.19305 10.6847 5.19305 10.3153 5.42085 10.0875L8.50838 7.00001L5.42085 3.91249C5.19305 3.68468 5.19305 3.31534 5.42085 3.08753C5.64866 2.85972 6.01801 2.85972 6.24581 3.08753L9.74581 6.58753C9.97362 6.81534 9.97362 7.18468 9.74581 7.41249L6.24581 10.9125C6.01801 11.1403 5.64866 11.1403 5.42085 10.9125Z" fill="#333333"/>
        </svg>`,
        callback(data, { pageNumber }) {
          _this.articleListPageChange(pageNumber, pageSize);
        },
      });
    }

    articleListPageChange(num, size) {
      $('.all-article-list .article-item').each(function () {
        const idx = $(this).index();
        if (idx >= (num - 1) * size && idx <= num * size - 1) {
          $(this).attr('data-visiable', true);
        } else {
          $(this).attr('data-visiable', false);
        }
      });
    }
  }

  customElements.define('blog-pages', BlogPages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-banner"] && !window.DesignMode) return;
  try {
    
  class BlogBanner extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const swiper = new Swiper('.blog-banner-swiper', {
        mousewheelControl: true,
        effect: 'fade',
      });

      $('.bb-swiper-prev').on('click', function () {
        console.log(11);
        const id = $(this).siblings('.blog-banner-swiper').attr('id');
        if (swiper.length) {
          const t = swiper.filter((swi) => swi.el.getAttribute('id') === id)[0];
          t?.slidePrev();
        } else {
          swiper.slidePrev();
        }
      });

      $('.bb-swiper-next').on('click', function () {
        console.log(22);
        const id = $(this).siblings('.blog-banner-swiper').attr('id');
        if (swiper.length) {
          const t = swiper.filter((swi) => swi.el.getAttribute('id') === id)[0];
          t?.slideNext();
        } else {
          swiper.slideNext();
        }
      });
    }
  }

  customElements.define('blog-banner', BlogBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-category-main"] && !window.DesignMode) return;
  try {
    
  class BlogPages extends HTMLElement {
    constructor() {
    super();
    this.init();
  }

  init() {
    const _this = this;
    const pageSize = window.screen.width < 768 ? +$('.blog-category-main .blog-pages').attr('data-mob-group') : +$('.blog-category-main .blog-pages').attr('data-group');
    const dataSource = [];

    $('.blog-category-main .article-item').each(function () {
      const idx = $(this).index();
      dataSource.push(idx);
    });


  $('.blog-category-main .blog-pagination-wrap').pagination({
      dataSource,
      pageSize,
      activeClassName: 'actived',
      prevText: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M8.57915 3.08751C8.80695 3.31532 8.80695 3.68466 8.57915 3.91247L5.49162 6.99999L8.57915 10.0875C8.80695 10.3153 8.80695 10.6847 8.57915 10.9125C8.35134 11.1403 7.98199 11.1403 7.75419 10.9125L4.25419 7.41247C4.02638 7.18466 4.02638 6.81532 4.25419 6.58751L7.75419 3.08751C7.98199 2.8597 8.35134 2.85971 8.57915 3.08751Z" fill="#333333"/>
      </svg>`,
      nextText: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M5.42085 10.9125C5.19305 10.6847 5.19305 10.3153 5.42085 10.0875L8.50838 7.00001L5.42085 3.91249C5.19305 3.68468 5.19305 3.31534 5.42085 3.08753C5.64866 2.85972 6.01801 2.85972 6.24581 3.08753L9.74581 6.58753C9.97362 6.81534 9.97362 7.18468 9.74581 7.41249L6.24581 10.9125C6.01801 11.1403 5.64866 11.1403 5.42085 10.9125Z" fill="#333333"/>
      </svg>`,
      callback(data, { pageNumber }) {
        _this.pageChange(pageNumber, pageSize);
      },
    });
  }

  pageChange(num, size) {
      $('.blog-category-main .article-item').each(function () {
        const idx = $(this).index();
        if (idx >= (num - 1) * size && idx <= num * size - 1) {
          $(this).attr('data-visiable', true);
        } else {
          $(this).attr('data-visiable', false);
        }
      });
    }
  }

customElements.define('blog-pages', BlogPages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-nav"] && !window.DesignMode) return;
  try {
    
  class BlogNav extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      $('.blog-categories-select').on('click', function () {
        const actived = $('.categories-options').hasClass('actived');
        actived ? $('.categories-options').removeClass('actived') : $('.categories-options').addClass('actived');
      });

      $('body').on('click', function (event) {
        const el = $('.blog-categories-select')[0];
        if (!el || el.contains(event.target)) {
          return;
        }
        $('.categories-options').removeClass('actived');
      });
    }
  }

  customElements.define('blog-nav', BlogNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-video-list"] && !window.DesignMode) return;
  try {
    
class BlogVideoList extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.initPagination();
  }

  init() {
    const swiper = new Swiper(".blog-video-swiper", {
      slidesPerView: 4,
      spaceBetween: 17,
      mousewheelControl: true,
    });

    $(".bv-swiper-prev").on("click", function () {
      const id = $(this).siblings(".blog-video-swiper").attr("id");
      if (swiper.length) {
        const t = swiper.filter((swi) => swi.el.getAttribute("id") === id)[0];
        t?.slidePrev();
      } else {
        swiper.slidePrev();
      }
    });

    $(".bv-swiper-next").on("click", function () {
      const id = $(this).siblings(".blog-video-swiper").attr("id");
      if (swiper.length) {
        const t = swiper.filter((swi) => swi.el.getAttribute("id") === id)[0];
        t?.slideNext();
      } else {
        swiper.slideNext();
      }
    });

    $(".blog-video-list .learn-more-btn").on("click", function () {
      $(this).hide();
      $(".blog-video-list .blog-video-wrap").each(function () {
        $(this).attr("data-visiable", true);
        if (swiper.length) {
            swiper.forEach((swi) => swi.update())
        }
      });
    });
  }

  initPagination() {
    const _this = this;
    const pageSize = +$(".blog-video-list .blog-pages").attr("data-group");
    const dataSource = [];

    $(".blog-video-list .blog-video-mob-wrap .blog-video-item").each(function () {
      const idx = $(this).index();
      dataSource.push(idx);
    });

    $(".blog-video-list .blog-pagination-wrap").pagination({
      dataSource,
      pageSize,
      activeClassName: "actived",
      prevText: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M8.57915 3.08751C8.80695 3.31532 8.80695 3.68466 8.57915 3.91247L5.49162 6.99999L8.57915 10.0875C8.80695 10.3153 8.80695 10.6847 8.57915 10.9125C8.35134 11.1403 7.98199 11.1403 7.75419 10.9125L4.25419 7.41247C4.02638 7.18466 4.02638 6.81532 4.25419 6.58751L7.75419 3.08751C7.98199 2.8597 8.35134 2.85971 8.57915 3.08751Z" fill="#333333"/>
        </svg>`,
      nextText: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M5.42085 10.9125C5.19305 10.6847 5.19305 10.3153 5.42085 10.0875L8.50838 7.00001L5.42085 3.91249C5.19305 3.68468 5.19305 3.31534 5.42085 3.08753C5.64866 2.85972 6.01801 2.85972 6.24581 3.08753L9.74581 6.58753C9.97362 6.81534 9.97362 7.18468 9.74581 7.41249L6.24581 10.9125C6.01801 11.1403 5.64866 11.1403 5.42085 10.9125Z" fill="#333333"/>
        </svg>`,
      callback(data, { pageNumber }) {
        _this.videoListPageChange(pageNumber, pageSize);
      },
    });
  }

  videoListPageChange(num, size) {
    $(".blog-video-list .blog-video-item").each(function () {
      const idx = $(this).index();
      if (idx >= (num - 1) * size && idx <= num * size - 1) {
        $(this).attr("data-visiable", true);
      } else {
        $(this).attr("data-visiable", false);
      }
    });
  }
}

  customElements.define('blog-video-list', BlogVideoList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christma-signup-section"] && !window.DesignMode) return;
  try {
    
  class ChristmaSignupSection extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.event();
      this.getDiscount();
      this.setCopyEvent();
      this.setIp();
    }

    init() {
      const $el = $('.christma-signup-section');
      this.start = new Date($el.data('start'));
      this.end = new Date($el.data('end'));
      this.days = [];

      document.addEventListener('serverTimeUpdate', () => {
        const serverTime = new Date(Shopify.serverTime);
        this.days = this.listDaysUntilCurrent(this.start, serverTime);
        const signMap = localStorage.getItem('signMap') ? JSON.parse(localStorage.getItem('signMap')) : {};
        this.days.forEach((item, index) => {
          $el.find(`.js-signup-day`).eq(index).removeClass('disabled');
          if (index === this.days.length - 1) {
            $el.find(`.js-signup-day`).eq(index).addClass('active');
          }
          if (signMap[index]) {
            $el.find(`.js-signup-day`).eq(index).addClass('signed');
          }
        });
      });
    }

    event() {
      const _this = this;

      $('.js-signup-day').on('click', function (e) {
        const isdisable = $(this).hasClass('disabled');
        if (isdisable) {
          return;
        }
        _this.sign($(this).index());
      });
      $('.js-signup-btn').on('click', function (e) {
        _this.sign(_this.days.length - 1);
      });

      $('.js-popup-close-btn').on('click', function (e) {
        $('.js-pop-wrap').hide();
        $('.js-overlay-wrap').hide();
      });

      $('.js-product-buy').on('click', function (e) {
        const vid = $(this).data('vid');
        const discount = $(this).data('code');
        const idx = $(this).attr('idx');
        const $parents = $('.js-signup-day').eq(idx);
        _this.buyNow(vid, discount);
        _this.ctaEventTrack($parents, 'begin_checkout');
      });

      $('.js-sms-btn').on('click', function () {
        $('#smsPopup').show();
        $('.js-overlay-wrap').show();
      });

      $('.js-subscribe-btn').on('click', function () {
        $('#subscribePopup').show();
        $('.js-overlay-wrap').show();
      });
    }

    sign(index) {
      const $cur = $('.js-signup-day').eq(index);
      const type = $cur.data('type');
      const signMap = localStorage.getItem('signMap') ? JSON.parse(localStorage.getItem('signMap')) : {};

      $('.js-overlay-wrap').show();
      $cur.addClass('signed');
      signMap[index] = true;
      localStorage.setItem('signMap', JSON.stringify(signMap));

      if (type === 'product') {
        const title = $cur.data('product-title');
        const desc = $cur.data('product-desc');
        const price = $cur.data('product-price');
        const img = $cur.data('product-img');
        const sale = $cur.data('product-sale');
        const salePrice = $cur.data('product-sale-price');
        const code = $cur.data('product-code');
        const url = $cur.data('product-url');
        const vid = $cur.data('product-vid');
        const available = $cur.data('prudct-available');

        $('.js-product-code').text(code);
        $('.js-popup-product-title').text(title);
        $('.js-popup-product-desc').text(desc);
        $('.js-popup-product-img').attr('src', img);
        $('.js-off-tag').text(sale);
        $('.js-product-learn').attr('href', url);
        $('.js-product-buy')
          .attr('data-vid', vid)
          .attr('data-code', code || '')
          .attr('idx', index);

        if (sale) {
          $('.js-popup-product-price').text(salePrice);
          $('.js-popup-product-wasprice').text(price);
          $('.js-product-tag').show();
          $('.js-pcode-wrap').show();
        } else {
          $('.js-popup-product-price').text(price);
          $('.js-popup-product-wasprice').text('');
          $('.js-product-tag').hide();
          $('.js-pcode-wrap').hide();
        }

        if (available) {
          $('.js-btn-wrap').show();
          $('.js-sold-out-wrap').hide();
        } else {
          $('.js-btn-wrap').hide();
          $('.js-sold-out-wrap').show();
        }

        $('#copyPopup').show();
      } else if (type === 'code') {
        const code = $cur.data('code');
        $('.js-data-code').text(code);
        $('#codePopup').show();
      } else if (type === 'copy') {
        const title = $cur.data('copy-title');
        const desc = $cur.data('copy-desc');
        const showCountdown = $cur.data('show-countdown');
        if (showCountdown) {
          const diffInDays = this.daysBetweenDates(this.days[index], this.end);
          $('.js-popup-countdown').find('span').text(diffInDays);
          $('.js-popup-countdown').show();
        } else {
          $('.js-popup-countdown').hide();
        }
        $('#popup').show();
        $('.js-popup-title').text(title);
        $('.js-popup-desc').text(desc);
      }
    }

    listDaysUntilCurrent(startDateStr, currentDateStr) {
      const startDate = new Date(startDateStr);
      const currentDate = new Date(currentDateStr);
      let dateArray = [];

      for (let date = new Date(startDate); date <= currentDate; date.setDate(date.getDate() + 1)) {
        dateArray.push(this.formatDate(new Date(date)));
      }

      return dateArray;
    }

    daysBetweenDates(startDate, endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      // 计算两个日期之间的毫秒差
      const diffInTime = end.getTime() - start.getTime();

      // 将毫秒差转换为天数
      const diffInDays = diffInTime / (1000 * 3600 * 24);

      return Math.floor(Math.abs(diffInDays)); // 返回绝对值以避免负数
    }

    formatDate(date) {
      return (
        date.getFullYear() +
        '-' +
        String(date.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(date.getDate()).padStart(2, '0')
      );
    }

    execCoy(text) {
      const input = document.createElement('INPUT');
      input.style.opacity = 0;
      input.style.position = 'absolute';
      input.style.left = '-100000px';
      document.body.appendChild(input);

      input.value = text;
      input.select();
      input.setSelectionRange(0, text.length);
      document.execCommand('copy');
      document.body.removeChild(input);
      return true;
    }

    setCopyEvent() {
      const _this = this;
      const $copy = $('.js-code-copy');
      const copy = $copy.data('copy');
      const copied = $copy.data('copied');
      let lock = false;
      let timer;

      $copy.on('click', function () {
        const code = $(this).siblings('.js-product-code').text();
        if (lock) return;
        _this.execCoy(code);
        lock = true;
        timer && clearTimeout(timer);
        $(this).text(copied);

        timer = setTimeout(() => {
          lock = false;
          $(this).text(copy);
        }, 3000);
      });
    }

    getDiscount() {
      const skus = [];

      $('[data-product-sku]').each(function () {
        skus.push($(this).data('product-sku'));
      });

      const data = {
        skus,
        shopify_domain: Shopify.shop,
      };

      $.ajax({
        type: 'GET',
        url: '/apps/pp/shopifyservices/coupons/by_skus',
        data,
        success(res) {
          if (res) {
            $('[data-product-sku]').each(function () {
              const sku = $(this).data('product-sku');
              // const $sale = $(this).find('.js-off-tag');
              let sale = '';
              if (res[sku]) {
                const { title, value_type, value_style, value, variant_price4wscode } = res[sku][0];

                switch (value_type) {
                  case 'fixed_amount':
                    sale = value_style;
                    break;
                  case 'percentage':
                    sale = Math.abs(parseInt(value)) + '%';
                    break;
                }

                $(this).attr('data-product-code', title);
                $(this).attr('data-product-sale', sale);
                $(this).attr('data-product-sale-price', Shopify.theme.formatPirce(variant_price4wscode));
              }
            });
          }
        },
      });
    }

    buyNow(vid, discount) {
      const line_items = [
        {
          variant_id: vid,
          quantity: 1,
        },
      ];

      const checkout = {
        line_items,
        presentment_currency: Currency.shop_currency,
        is_upstream_button: true,
        page_type: 'product',
        secret: true,
        wallet_name: 'Checkout',
      };

      if (discount) {
        checkout.discount = discount;
      }
      Shopify.theme.bundleBuynow({
        authorization: Shopify.storefront,
        checkout,
        onSuccess: () => {},
        onError: (err) => $.dialog({ title: err.message, content: err.description, type: 'red' }),
      });
    }

    setIp() {
      if (Country.code !== 'us') return;
      $.ajax({
        headers: Shopify.contentCreator.pastApi.getHeaders(),
        url: '/apps/pp/geolocation',
        type: 'GET',
        success: (body) => {
          const { country = {} } = body;
          const { code = '' } = country;
          if (code.toLocaleLowerCase() !== 'us') {
            $('.js-sms-btn-wrap').hide();
            $('.js-subscribe-btn-wrap').show();
          }
        },
        error: (err) => {},
      });
    }

    ctaEventTrack($parents, ctaType) {
      const sku = $parents.data('product-sku');
      const price = Shopify.theme.parseGlobalCurrency($parents.data('product-price').trim());
      const $salePrice = $parents.data('product-sale-price');
      const salePrice = $salePrice ? Shopify.theme.parseGlobalCurrency($salePrice.trim()) : price;
      const coupon = $parents.data('product-code') || '';
      const discount = $parents.data('product-sale') || '';
      const name = $parents.data('name') || '';
      const title = $parents.data('product-title') || '';
      const pageHandle = $('.christma-signup-section').data('handle');
      const position = $('.js-signup-section-title').text().trim() || '';
      const map = {
        add_to_cart: 'Added Product',
        begin_checkout: 'BuyNow',
      };

      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: ctaType,
        event_parameters: {
          page_group: 'Activity Page_' + pageHandle,
          currency: Currency.shop_currency,
          value: salePrice,
          position,
          coupon,
          items: [
            {
              item_name: name,
              item_id: sku,
              item_brand: 'Eufy',
              item_category: '',
              item_variant: title,
              price,
              coupon,
              discount,
              quantity: 1,
            },
          ],
        },
      });

      window.dataLayer.push({
        event: 'eeEvent',
        eventCategory: 'EnhancedEcommerce',
        eventAction: map[ctaType],
        eventLabel: sku,
        nonInteraction: false,
        ecommerce: {
          currencyCode: Currency.shop_currency,
          add: {
            products: [
              {
                name,
                id: sku,
                category: '',
                categoryName: '',
                brand: 'Eufy',
                variant: title,
                price,
                quantity: 1,
              },
            ],
          },
        },
      });
    }
  }

  customElements.define('christma-signup-section', ChristmaSignupSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["firework-1-1"] && !window.DesignMode) return;
  try {
    
  class Firework11 extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    serviceTrack(category, action, type) {
      dataLayer.push({
        event: 'uaEvent',
        eventCategory: category,
        eventAction: action,
        eventLabel: type,
        nonInteraction: true,
      });
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'lp_button',
        event_parameters: {
          page_group: category,
          position: action,
          button_name: type,
        },
      });
    }

    // handleFireworkActive() {
    //   $('.firework-status').addClass('firework-active');
    //   $('.firework-available').addClass('firework-active');
    //   $('.firework-ask').show();
    // }

    // handleFireworkUnActive() {
    //   $('.firework-status').removeClass('firework-active');
    //   $('.firework-available').removeClass('firework-active');
    //   $('.firework-ask').hide();
    // }

    handleFirework11Online() {
      const _this = this;
      const showLiveHelper = $('.firework-1-1-wrap').data('show-live-helper');
      if (!showLiveHelper) return;
      $('.global-float-pop.livechat').hide();
      $('.appleBusinessChat').hide();
      $('.fw-live-helper').attr('data-fw-available', true);
      // $(".firework-1-1-container").show();
      // $('.fw-live-helper').attr('data-fw-available', true).hide();

      // const timer1 = setTimeout(() => {
      //   _this.handleFireworkActive();
      //   clearTimeout(timer1);
      //   const timer2 = setTimeout(() => {
      //     _this.handleFireworkUnActive();

      //     $('.firework-1-1-container').hover(
      //       function() {
      //         // 鼠标进入时的操作
      //         _this.handleFireworkActive();
      //       },
      //       function() {
      //         // 鼠标离开时的操作
      //         _this.handleFireworkUnActive();
      //       }
      //     );
      //     clearTimeout(timer2);
      //   }, 3000);
      // }, 2000);

      const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            for (let addedNode of mutation.addedNodes) {
              if (addedNode.id === 'fw-player') {
                addedNode.remove();
                console.log('fw-player removed');
              }
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });

      _this.serviceTrack('firework', 'icon', 'impression');
    }

    handleFirework11Unline() {
      const _this = this;
      const showAppleBusinessChat = $('.firework-1-1-wrap').data('show-apple-business-chat');
      const isIOS = !!window.navigator.userAgent.match(/iP(ad|hone|od)|Mac OS/);
      // $('.firework-1-1-container').hide();
      $('.fw-live-helper').hide();
      if (showAppleBusinessChat && isIOS) {
        $('.appleBusinessChat').css('display', 'flex');
        $('.apple-business-chat-container').show();
        $('.global-float-pop.livechat').hide();

        _this.serviceTrack('Apple business chat', 'icon', 'impression');
      } else {
        $('.global-float-pop.livechat').show();
      }
    }

    init() {
      const _this = this;
      // start_ai_generated
      // 加载firework-1-1.js
      $.ajax({
        url: 'https://fireworkapi1.com/api/chat_channels/W5EPvy/agents_availability',
        // end_ai_generated
        success: function (body) {
          const { agents_available } = body;
          // start_ai_generated
          if (agents_available) {
            // end_ai_generated
            _this.handleFirework11Online();
          } else {
            _this.handleFirework11Unline();
          }
        },
      });
      $('.firework-1-1-container').on('click', function () {
        $('.fw-live-helper').show();
        $('.firework-1-1-container').hide();
        _this.serviceTrack('firework', 'icon', 'click');
      });
    }
  }
  customElements.define('firework-1-1', Firework11);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fix-firework"] && !window.DesignMode) return;
  try {
    
  class FixFirework extends HTMLElement {
    constructor() {
      super();
      // this.event();
      this.init();
      this.fullscreen();
      this.thumbnailClick();
    }

    init() {
      const _this = this;
      const $el = $('.fix-firework');
      const start = $el.data('start');
      const end = $el.data('end');
      // const durs = (Shopify.livestream && Shopify.livestream.list) || {};

      // if (durs.length) {
      //   durs.map((item) => {
      //     const start = item.reminder_start;
      //     const end = item.reminder_end;
      //     _this.setEvent(start, end);
      //   });
      // } else {
      this.setEvent(start, end);
      // }
    }

    setEvent(s, e) {
      if (!s) return;
      const _this = this;
      const now = new Date().getTime();
      // const startTime = Shopify.theme.icsDate2jsDate(s);
      // const endTime = Shopify.theme.icsDate2jsDate(e);
      const start = s ? s.replace(/-/g, '/') : now;
      const end = e ? e.replace(/-/g, '/') : now;
      const startTime = new Date(start).getTime();
      const endTime = new Date(end).getTime();

      if ((now >= startTime && !e) || (now >= startTime && now <= endTime)) {
        this.event();
      } else {
        const { height } = window.screen;
        let status = true;
        document.addEventListener('scroll', () => {
          if (window.scrollY >= height && status) {
            status = false;
            _this.fullscreen();
            _this.thumbnailClick();
            window._fwn && window._fwn.player && window._fwn.player.close();
          }
        });
      }
    }

    event() {
      const { height } = window.screen;
      document.addEventListener('scroll', () => {
        if (document.getElementById('hideFixFirework') && window.scrollY >= height) {
          document.getElementById('hideFixFirework').remove();
        }
      });
    }

    fullscreen() {
      document.addEventListener('fw:player:transition', function (event) {
        if ((event.detail.transitionTo = 'fullscreen')) {
          document.getElementById('hideFixFirework').remove();
        }
      });
    }

    thumbnailClick() {
      document.addEventListener('fw:embed-feed:thumbnail-click', function (event) {
        const style = document.getElementById('hideFixFirework');
        style && style.remove();
      });
    }
  }
  customElements.define('fix-firework', FixFirework);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giftcard-pop"] && !window.DesignMode) return;
  try {
    
  class GiftcardPop extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const _this = this;
      const $el = $('.giftcard-pop');
      const $input = $el.find('.model-input');
      const $params = $el.data('params');
      const params = $params ? JSON.parse(decodeURIComponent($params)) : [];
      this.submitLock = false;
      $el.each(function () {
        console.log(6, params);
        const flags = [];
        params &&
          params.map((item, idx) => {
            const val = Shopify.theme.getURLParamsV2(item.label);
            if (val && item.val.includes('*')) {
              _this.email = val;
            }
            if (val && val === item.val) {
              flags.push('true');
            } else {
              flags.push('false');
            }
          });
        if (flags.includes('true') && localStorage.getItem('giftcard_lost_user') !== _this.email) {
          _this.modelShow($el, $input);
        }
      });

      $el.find('.js-close').on('click', function () {
        $el.addClass('!hidden');
      });

      $el.find('.js-hint-close').on('click', function () {
        $el.addClass('!hidden');
      });

      $el.find('.js-submit').on('click', function () {
        const val = $input.val();
        const regExp =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!val) _this.showError('fill');
        if (val) {
          if (regExp.test(val)) {
            _this.submit(val);
            _this.submitLock = true;
            return;
          } else {
            _this.showError('email');
          }
        }
      });
    }

    submitStatus(type) {
      const $el = $('.giftcard-model');
      if (type === 'loading') {
        $el.find('.js-submit').addClass('!hidden');
        $el.find('.js-submit-loading').removeClass('!hidden');
      } else {
        $el.find('.js-submit').removeClass('!hidden');
        $el.find('.js-submit-loading').addClass('!hidden');
      }
    }

    showError(type, txt) {
      const $el = $('.giftcard-model');
      $el
        .find('.js-model-error')
        .removeClass('!hidden')
        .find('.js-error-tips')
        .addClass('hidden')
        .siblings(`.js-error-${type}`)
        .removeClass('hidden');
      if (txt) $el.find(`.js-error-${type}`).text(txt);
      this.hideError();
    }

    hideError() {
      const $el = $('.giftcard-model');
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        $el.find('.js-model-error').addClass('!hidden');
        $el.find('.js-error-tips').addClass('hidden');
      }, 6000);
    }

    submit(val) {
      console.log(9);
      const _this = this;
      if (!window.grecaptcha || _this.submitLock) return;
      this.submitStatus('loading');
      grecaptcha.ready(() => {
        grecaptcha.execute(ShopMetafields.recaptcha, { action: 'gift_card' }).then((recaptcha) => {
          Shopify.theme.recaptchaCollect({ action: "gift_card" })
          $.ajax({
            headers: {
              recaptcha,
              "X-Recaptcha-Sitekey": ShopMetafields.recaptcha,
              'node-validate': 'skip',
              'X-Application-Name': `${Shopify.shop.split('.')[0]}-shopify`,
            },
            type: 'POST',
            url: '/apps/pp/rainbowbridge/gift-card/get-gift-card-with-customer-tag/new',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({
              shopify_domain: `${Shopify.shop}`,
              email: val
            }),
            complete: function (body) {
              const res = body.responseJSON;
              const time = Shopify.serverTime ? new Date(Shopify.serverTime).getTime() : new Date().getTime();
              _this.submitLock = false;
              _this.submitStatus('unloading');
              if (res.code === 200) {
                localStorage.setItem('giftcard_lost_user', val);
                localStorage.setItem('giftcard_lost_user_time', time);
                $('.model-part').hide();
                $('.model-part-res').show();
                Shopify.contentCreator.pastApi.subscribe_activities_emails({
                  params: {
                    email: val,
                    genre: 'lost_user_recall_giftcard',
                    shopify_domain: `${Shopify.shop}`,
                    promise_subscribe: false,
                    single_brand_subscribe: true,
                  },
                  fn: function () {
                    console.log('subscribe_activities_emails success');
                  },
                })
              } else if (res.code === 404) {
                _this.showError('notAllow');
              } else if (res.code === 1002) {
                localStorage.setItem('giftcard_lost_user', val);
                _this.showError('received');
              } else if (res.code === 1101) {
                _this.showError('expired');
              } else if (res.code === 500) {
                _this.showError('common', res.msg);
              }
            },
          });
        });
      });
    }

    modelShow(el, input) {
      el.show();
      input.val(this.email);
    }
  }
  customElements.define('giftcard-pop', GiftcardPop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !window.DesignMode) return;
  try {
    
  class ImageBanner extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        videoPc: this.querySelector('.js-pc-media-loader'),
        videoMb: this.querySelector('.js-mb-media-loader'),
        imgPcWrap: this.querySelector('.js-pc-image-wrap'),
        imgMbWrap: this.querySelector('.js-mb-image-wrap'),
      };

      this.setVideoLoad();
    }

    setVideoLoad() {
      const w = window.innerWidth || document.documentElement.clientWidth;

      if (w > 768) {
        this.videoLazyLoad(this.elements.videoPc, () => {
          this.elements.imgPcWrap.style.display = 'none';
        });
      } else {
        this.videoLazyLoad(this.elements.videoMb, () => {
          this.elements.imgMbWrap.style.display = 'none';
        });
      }
    }

    videoLazyLoad(video, cb) {
      if (!video) return;
      video.setAttribute('src', video.getAttribute('data-src'));
      video.load();
      video.addEventListener('loadedmetadata', () => {
        video.setAttribute('style', '');
        cb && cb();
      });
    }
  }

  customElements.define('image-banner', ImageBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-image-list"] && !window.DesignMode) return;
  try {
    
  class IndexImageList extends HTMLElement {
    constructor() {
      super();
      this.swiperInit();
    }

    swiperInit() {
      if ($(window).width() > 1024) return;
      const swiper = new Swiper('.index-imglist-container', {
        slidesPerView: 'auto',
        scrollbar: {
          el: '.product-swiper-process',
          hide: false,
          draggable: true,
          dragSize: 60,
          snapOnRelease: false,
        },
      });
    }
  }

  customElements.define('index-image-list', IndexImageList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-product-section"] && !window.DesignMode) return;
  try {
    
  class ProductSection extends HTMLElement {
    constructor() {
      super();
      this.el = this.querySelector('.index-product-swiper');
      this.isRecom = this.el.getAttribute('data-is-recom');
      this.isSwiperAuto = this.el.getAttribute('data-is-swiper-auto');

      if (this.isRecom === 'true') {
        this.getRecommend(() => {
          this.init();
        });
      } else {
        this.init();
      }
    }

    init() {
      this.swiperInit();
      this.getDiscount();
      this.resizeTitleAutoHeight();
    }

    getRecommend(cb) {
      const _this = this;
      const { shop } = Shopify;
      const parser = (window.UAParser && new UAParser()) || '';
      const ua = (parser && parser.getResult()) || {};
      const gaid = document.cookie.match(/_ga=(.+?);/);
      const $el = $('.index-product-section');
      const curSku = $el.data('cur-sku');
      let skus = curSku || '';
      const user_id = gaid ? gaid[1].split('.').slice(-2).join('.') : '';
      const device_type = this.getDeviceCategory();
      const browser_type = ua?.browser?.name || '';
      const country = (Country && Country.name) || '';
      const isIndex = location.pathname === '/' ? true : false;
      const data = isIndex
        ? JSON.stringify({
            shopify_domain: shop,
            user_id,
            device_type,
            browser_type,
            country,
            limit: 20,
          })
        : {
            user_id,
            shopify_domain: shop,
            limit: 12,
            skus,
          };
      const type = isIndex ? 'POST' : 'GET';

      this.sku = skus;

      $.ajax({
        url: '/apps/pp/rainbowbridge/personalize/relation',
        data,
        contentType: 'application/json',
        dataType: 'json',
        type,
        success({ data }) {
          const res = isIndex ? data : data[skus];
          res && _this.setRecommendData(res);
          cb && cb();
        },
      });
    }

    setRecommendData(data) {
      const _this = this;
      const $el = $(`#${this.el.id}`);
      const $slide = $el.find('.product-swiper-slide').eq(0).clone();
      const $wrapper = $el.find('.swiper-wrapper');
      const refVal = location.pathname === '/' ? 'index_recom_Bundle' : 'listing_bottom_Bundle';
      const items = [];
      let html = '';

      if (!data.length) return;

      data.map((item, idx) => {
        $slide.find('.product-slide-content').attr('data-sku', item.sku).attr('data-handle', item.handle);
        const variant_url = _this.handleVariantUrl(item);
        $slide.find('a').attr('href', this.urlParmsAppend(variant_url, 'ref', refVal));
        $slide.find('img').attr('src', item.variant_image);
        $slide.find('img').attr('data-src', item.variant_image);
        $slide.find('.product-slide-title a').text(item.product_title);
        $slide
          .find('.cur-money')
          .attr('data-price', +item.variant_price * 100)
          .text(this.formatPirce(item.variant_price, Shopify.country.toLowerCase(), item.currency));
        $slide.find('.was-price').text('');
        html += `<li class="swiper-slide product-swiper-slide">${$slide.html()}</li>`;

        items.push({
          item_id: item.sku,
          item_name: item.product_title,
          item_variant: item.variant_title,
          price: +item.variant_price4wscode || +item.variant_price,
          index: idx + 1,
        });
      });

      $wrapper.html(html).removeClass('is-justify-center');

      const isIndex = location.pathname === '/' ? true : false;
      const ga4ItemListName = $el.data('ga4-item-list-name');
      const ga4PageGroup = $el.data('ga4-page-group');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((item) => {
          const { target } = item;
          const sku = $(target).data('sku');
          if (item.isIntersecting) {
            _this.track({
              items: items.filter((i) => i.item_id === sku),
              name: 'view_item_list',
              group: isIndex ? ga4PageGroup : ga4PageGroup + _this.sku,
              listName: ga4ItemListName,
            });
          }
        });
      });

      document.querySelectorAll(`#${this.el.id} .product-slide-content`).forEach((el) => {
        io.observe(el);
      });

      $el
        .find('.product-img-box a, .product-slide-title a, .product-info-box a.index-btn-link')
        .on('click', function () {
          const idx = $(this).parents('.product-swiper-slide').index();
          const action = $(this).data('type');
          _this.track({
            items: [items[idx]],
            name: 'select_item',
            group: isIndex ? ga4PageGroup : ga4PageGroup + _this.sku,
            listName: ga4ItemListName,
            action,
          });
        });
    }

    handleVariantUrl({ variant_shopify_id, variant_url }) {
      const regex = /variant_id=(\d+)/;
      const replacedString = variant_url.replace(regex, `variant=${variant_shopify_id}`) || '';
      return replacedString;
    }

    urlParmsAppend(href, label, val) {
      return href.includes('?') ? `${href}&${label}=${val}` : `${href}?${label}=${val}`;
    }

    track({ name, group, listName, items, action }) {
      const data = {
        event: 'ga4Event',
        event_name: name,
        event_parameters: {
          page_group: group,
          item_list_name: listName,
          items,
        },
      };
      if (action) data.event_parameters.action = action;
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push(data);
    }

    getDeviceCategory() {
      var userAgent = navigator.userAgent;

      if (/mobile/i.test(userAgent)) {
        return 'mobile';
      } else if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
        return 'tablet';
      } else if (/smart-tv|smarttv|googletv|appletv|hbbtv|pov_tv|netcast.tv/i.test(userAgent)) {
        return 'smart tv';
      } else {
        return 'desktop';
      }
    }

    swiperInit() {
      const $el = $(`#${this.el.id}.index-product-swiper`);
      const next = this.querySelector('.product-swiper-next-btn');
      const prev = this.querySelector('.product-swiper-prev-btn');
      const isIndex = location.pathname === '/';

      const swiper = new Swiper($el[0], {
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        noSwiping: true,
        scrollbar: {
          el: $el.find('.product-swiper-process'),
          hide: false,
          draggable: true,
          dragSize: 60,
          snapOnRelease: false,
        },
        on: {
          progress() {
            if (this.progress > 0) {
              prev && prev.classList.add('actived');
            } else {
              prev && prev.classList.remove('actived');
            }

            if (this.progress === 1) {
              next && next.classList.remove('actived');
            } else {
              next && next.classList.add('actived');
            }
          },
        },
        breakpoints: {
          1920: {
            slidesPerView: this.isSwiperAuto ? 'auto' : isIndex ? 4 : 6,
          },
          1440: {
            slidesPerView: this.isSwiperAuto ? 'auto' : isIndex ? 4 : 5,
          },
          1024: {
            slidesPerView: this.isSwiperAuto ? 'auto' : 4,
          },
          768: {
            slidesPerView: 'auto',
          },
          320: {
            slidesPerView: 'auto',
          },
        },
      });

      next &&
        next.addEventListener('click', (e) => {
          const id = this.querySelector('.index-product-swiper').getAttribute('id');
          if (swiper.length) {
            const t = swiper.filter((swi) => swi.el.getAttribute('id') === id)[0];
            t?.slideNext();
          } else {
            swiper.slideNext();
          }
        });

      prev &&
        prev.addEventListener('click', (e) => {
          const id = this.querySelector('.index-product-swiper').getAttribute('id');
          if (swiper.length) {
            const t = swiper.filter((swi) => swi.el.getAttribute('id') === id)[0];
            t?.slidePrev();
          } else {
            swiper.slidePrev();
          }
        });
    }

    getDiscount() {
      const skus = [];
      const slides = [...this.querySelectorAll('.product-slide-content')];
      const _this = this;

      slides.map((item) => {
        skus.push(item.getAttribute('data-sku'));
      });

      if (!skus.length) return;

      $.ajax({
        type: 'GET',
        url: '/apps/pp/shopifyservices/coupons/by_skus',
        data: {
          skus,
          shopify_domain: Shopify?.shop,
        },
        success(data) {
          skus.forEach((sku) => {
            const ajaxData = data[sku] && data[sku][0];
            if (ajaxData) {
              const $cur_p = $(`.index-product-section [data-sku=${sku}]`);
              const priceStr = $cur_p.find('.cur-money').data('price');
              const price = priceStr / 100;
              const priceFormat = $cur_p.find('.cur-money').text();
              const offVal =
                ajaxData.value_type === 'percentage' ? `${ajaxData.percentage_sort_key}% ` : `${ajaxData.value_style} `;
              const priceNow =
                ajaxData.value_type === 'percentage'
                  ? +price - +price * (ajaxData.percentage_sort_key / 100)
                  : +price - ajaxData.fixed_amount_sort_key;
              const priceNowFormat = Math.floor(priceNow * 10000) / 10000;
              const priceNowWithSymbol = _this.formatPirce(
                priceNowFormat,
                Shopify.country.toLowerCase(),
                ajaxData.currency
              );

              $cur_p.find('.pro-discount-tag').show().find('.discount-count').html(offVal);
              $cur_p.find('.cur-money').text(priceNowWithSymbol).attr('data-price', priceNow);
              $cur_p.find('.was-price').text(priceFormat);
            }
          });
        },
        complete: function () {
          const abPriceDecimal = $('body').data('price-decimal');
          if (!Country?.priceDecimal || !Boolean(abPriceDecimal)) return;
          skus.forEach((sku) => {
            if (sku) {
              const $cur_p = $(`[data-sku=${sku}]`);
              const countryCodeUpperCase = Country?.code?.toUpperCase();
              // Shopify.theme.priceABTest($cur_p.find('.cur-money'), countryCodeUpperCase, 'index');
            }
          });
        },
      });
    }

    resizeTitleAutoHeight() {
      const _this = this;
      this.autoAlignTitleHight();
      document.addEventListener('resize', () => {
        _this.autoAlignTitleHight();
      });
    }

    autoAlignTitleHight() {
      const arr = [];
      $('.product-slide-title').each(function () {
        arr.push($(this).height());
      });

      $('.product-slide-title').each(function () {
        $(this).height(Math.max(...arr));
      });
    }

    formatPirce(num, local, currency) {
      if (typeof num !== 'number') {
        num = +num;
      }
      const site = {
        us: 'en-US',
        uk: 'en-GB',
        gb: 'en-GB',
        eu: 'de-DE',
        de: 'de-DE',
        ca: 'en-CA',
        nl: 'nl-NL',
        lu: 'de-DE',
        au: 'en-AU',
      };
      const name = site[local] || 'en-GB';
      const res = num
        .toLocaleString(name, {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        .replace(/\s*/g, '');
      return local === 'ca' ? `CA${res}` : res;
    }
  }

  customElements.define('product-section', ProductSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-recommend-cards"] && !window.DesignMode) return;
  try {
    

class RecommendCards extends HTMLElement {
  constructor() {
    super();
    this.swiperInit()
  }

  swiperInit() {
    const w = $(window).width()
    if (w >= 768 && w <= 1024) {
      const swiper = new Swiper('.recommend-cards-container', {
        slidesPerView: 'auto',
        scrollbar: {
          el: '.product-swiper-process',
          hide: false,
          draggable: true,
          dragSize: 60,
          snapOnRelease: false
        }
      })
    }
  }
}
customElements.define('recommend-cards', RecommendCards);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listing-product-v3"] && !window.DesignMode) return;
  try {
    
  class EModel extends HTMLElement {
    constructor() {
      super();
      this.$el = $('.e-model');
      this.event();
    }

    event() {
      const _this = this;
      this.$el.find('.js-model-colse').on('click', function () {
        _this.close();
      });
    }

    close() {
      this.$el.removeClass('actived').find('.model-wrap').css('max-width', '');
    }

    show(content, width) {
      this.$el
        .addClass('actived')
        .find('.model-wrap')
        .css('max-width', width || '')
        .find('.model-content')
        .html(content);
    }
  }

  class ProductImage extends HTMLElement {
    constructor() {
      super();
      this.swiperInit('medias');
      this.swiperInit('scene');
      this.tabInit();
    }

    swiperInit(type) {
      if (!document.querySelector(`.${type}-swiper-container`)) return;

      const prev = document.querySelector(`.js-${type}-prev-btn`);
      const next = document.querySelector(`.js-${type}-next-btn`);
      const _this = this;

      const mediasSwiper = new Swiper(`.${type}-swiper-container`, {
        loop: true,
        observer: true,
        observeParents: true,
        on: {
          slideChange() {
            const idx = document.querySelector(`.js-${type}-idx`);
            const url = this.slides[this.realIndex].querySelector('img').getAttribute('src');
            if (idx) idx.innerText = this.realIndex + 1;
            _this.track(this.realIndex + 1, url);
          },
        },
      });

      prev &&
        prev.addEventListener('click', () => {
          mediasSwiper.slidePrev();
        });

      next &&
        next.addEventListener('click', () => {
          mediasSwiper.slideNext();
        });
    }

    tabInit() {
      const set = [];
      const _this = this;
      $('.js-pi-tab-item').on('click', function () {
        const idx = $(this).index();
        const v = $('.product-video-container').find('.js-product-video');

        $(this).addClass('actived').siblings().removeClass('actived');
        $('.product-image-container')
          .eq(idx)
          .addClass('actived')
          .siblings('.product-image-container')
          .removeClass('actived');

        if ($('.product-image-container').eq(idx).hasClass('product-video-container')) {
          if (v.length) {
            if (!v.hasClass('loaded')) {
              v.attr('src', v.data('src'));
              v.removeAttr('data-src');
              v.addClass('loaded');
            }
            v[0].play();
          }
        } else {
          v.length && v[0].pause();
        }

        v.length &&
          v[0].addEventListener('timeupdate', () => {
            const progress = Math.floor((v[0].currentTime / v[0].duration) * 100);
            const scale = [0, 10, 25, 75, 100];

            if (scale.includes(progress) && !set.includes(progress)) {
              set.push(progress);
              _this.videoTrack(progress);
            }
          });
      });
    }

    track(idx, url) {
      const sku = $('.product').data('sku');

      window.dataLayer.push({
        event: 'uaEvent',
        eventCategory: 'click',
        eventAction: 'image_box',
        eventLabel: sku,
        nonInteraction: true,
      });

      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'small_carousel_switch',
        event_parameters: {
          page_group: 'Product Detail Page_' + sku,
          image: idx + '_' + url,
        },
      });
    }

    videoTrack(progress) {
      const sku = $('.product').data('sku');
      const title = $('.product').data('title');

      if (progress === 0) {
        window.dataLayer.push({
          event: 'uaEvent',
          eventCategory: 'Product Detail Page_' + sku,
          eventAction: 'watch_video',
          eventLabel: title,
        });

        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'video_start',
          event_parameters: {
            video_title: title,
            page_group: 'Product Detail Page_' + sku,
          },
        });
      } else if (progress > 0 && progress < 100) {
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'video_progress',
          event_parameters: {
            video_title: title,
            page_group: 'Product Detail Page_' + sku,
            video_percent: progress,
          },
        });
      } else if (progress === 100) {
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'video_complete',
          event_parameters: {
            video_title: title,
            page_group: 'Product Detail Page_' + sku,
          },
        });
      }
    }
  }

  class ProductDiscount extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.getReferralExclusiveCode();
      this.getDisount();
      this.setGroupBuySales();
      this.setCopyEvent();
      this.setFaqEvent();
    }

    getItemWithExpiry(key) {
      const itemString = localStorage.getItem(key);
      if (!itemString) {
        return null;
      }
      const item = JSON.parse(itemString);
      const now = new Date();

      // 检查是否过期
      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key, {
          domain: shopifyDomain,
          expires: 30,
        });
        return null;
      }
      return item;
    }

    getReferralExclusiveCode() {
      let queryParams = {};
      if (location.search.length) {
        let params = location.search.substr(1).split('&');
        for (let i = 0; i < params.length; i++) {
          let keyValue = params[i].split('=');
          if (keyValue.length) {
            queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
          }
        }
      }

      if (queryParams.utm_campaign) {
        const $el = $('#purchase .product');
        const $product = $(`#${$el[0].id}`);
        const listingReferralCode = $product.data('listing-referral-code');
        const referralExclusiveCode = this.getItemWithExpiry(`${Shopify.country}-collection-referral-exclusive-code`);
        if (listingReferralCode) {
          // start_ai_generated
          if (listingReferralCode?.utm_campaign === queryParams.utm_campaign) {
            return listingReferralCode;
          } else if (referralExclusiveCode && referralExclusiveCode?.value) {
            if (referralExclusiveCode?.value?.utm_campaign === queryParams.utm_campaign) {
              return referralExclusiveCode?.value;
            }
          }
          // end_ai_generated
        } else if (referralExclusiveCode && referralExclusiveCode?.value) {
          if (referralExclusiveCode?.value?.utm_campaign === queryParams.utm_campaign) {
            return referralExclusiveCode?.value;
          }
        }
      }
    }

    init() {
      this.$el = $('.product-discount');
    }

    getParams(skus) {
      const cookiesDiscount = Cookies.get('discount_code') || '';
      const stName = skus.length ? `channel_discount_${skus[0]}` : '';
      const isChannelDiscount = cookiesDiscount.includes('WSCH');

      const params = {
        skus,
        shopify_domain: Shopify.shop,
      };

      if (isChannelDiscount) {
        const date = new Date();
        const storage = {
          cookiesDiscount,
          expire: date.setDate(date.getDate() + 7),
        };
        localStorage[stName] = JSON.stringify(storage);
        params.channel = 'wsch';
        Cookies.remove('discount_code');
      }

      if (localStorage[stName]) {
        const storage = JSON.parse(localStorage[stName]);
        if (new Date().getTime() > storage.expire) {
          localStorage.removeItem(stName);
        } else {
          params.channel = 'wsch';
        }
      }

      return params;
    }

    getVariantsSkus() {
      const skus = [];
      $('.js-variant-item').each(function () {
        skus.push($(this).data('sku'));
      });

      return skus;
    }

    getDisount() {
      const _this = this;
      const $el = this.$el;
      const sku = $el.data('current-sku');
      const $elSkus = $el.data('skus').split(',');
      const variantsSkus = this.getVariantsSkus();
      const skus = [...$elSkus, ...variantsSkus];
      const customCode = $el.data('custom-code');
      const customSales = $el.data('custom-sales');
      const customEnds = $el.data('custom-ends');

      const referralExclusiveCode = this.getReferralExclusiveCode();
      if (referralExclusiveCode) {
        const $el = $('#purchase .product');
        const $product = $(`#${$el[0].id}`);
        const originalPrice = $product.data('origin-price') / 100;
        const { value_type, code, discountValue, fixed_amount_sort_key, value } = referralExclusiveCode;
        if (
          (value_type === 'fixed_amount' && originalPrice > Number(fixed_amount_sort_key)) ||
          value_type === 'percentage'
        ) {
          this.setCode({
            value_type: value_type,
            value_style: discountValue,
            title: code,
            fixed_amount_sort_key,
            value,
            currency: Shopify.currency.active,
            ...(value_type === 'percentage' && { discountValue }),
          });
          _this.$el.height(162).css('opacity', 1);
          return;
        }
      }

      if (customCode) {
        this.setCode({
          value_type: 'fixed_amount',
          value_style: customSales,
          title: customCode,
        });

        customEnds &&
          this.setCountdown({
            ends_at: customEnds,
          });

        return;
      }

      let data = this.getParams(skus);

      $.ajax({
        type: 'GET',
        url: '/apps/pp/shopifyservices/coupons/by_skus',
        data,
        success(res) {
          const resData = (res && res[sku] && res[sku][0]) || '';
          if (resData) {
            _this.setCode(resData);
            _this.setCountdown(resData);
            _this.$el.height(162).css('opacity', 1);
          } else {
            _this.$el.remove();
          }

          _this.setVariantsPrice(res);
        },
      });
    }

    setCode({ value_type, value_style, value, title, fixed_amount_sort_key, currency, discountValue }) {
      const $sale = this.$el.find('.js-discount-sales');
      const $code = this.$el.find('.js-discount-code');
      const $save = $('.js-price-save');
      const $groupBuy = $('.js-group-buynow');
      const hasGroupBuy = $groupBuy.length;

      $code.text(title);

      switch (value_type) {
        case 'fixed_amount':
          $sale.text(value_style);
          break;
        case 'percentage':
          $sale.text(Math.abs(parseInt(value)) + '%');
          break;
      }

      if (!hasGroupBuy) {
        if (discountValue) {
          $save.text(discountValue).parent().show();
        } else {
          $save.text(this.formatPirce(fixed_amount_sort_key, Shopify.country.toLowerCase(), currency)).parent().show();
        }
      }

      if (title.includes('WS24BF') || title.endsWith('BF')) {
        $('.coupon-wrap').addClass('bf-coupon-wrap');
      }
    }

    setGroupBuySales() {
      const $groupBuy = $('.js-group-buynow');
      const groubuySales = '' + $groupBuy.data('sales');
      const $save = $('.js-price-save');
      const formatSales = groubuySales.includes('%')
        ? groubuySales
        : Shopify.theme.formatPirce(parseFloat(groubuySales.replaceAll(Currency.symbol, '')));

      if ($groupBuy.length) {
        $save.text(formatSales).parent().show();
      }
    }

    setCountdown({ ends_at }) {
      const endsTime = ends_at ? new Date(ends_at).valueOf() : null;
      const dayTxt = this.$el.data('day');
      const daysTxt = this.$el.data('days');
      const todayTxt = this.$el.data('today');
      const overTxt = this.$el.data('over-times');
      const endsTxt = this.$el.data('ends');
      const $title = this.$el.find('.js-discount-title');
      let timer;

      if (endsTime) {
        timer = setInterval(() => {
          const nowTime = new Date().getTime();
          const distance = endsTime - nowTime;
          const { days, hours, minutes, seconds } = this.getFormatTimes(distance);

          if (distance < 0) {
            clearInterval(timer);
            this.$el.hide();
          } else {
            if (days >= 7) {
              $title.text(overTxt);
            } else if (days === 1) {
              $title.text(`${endsTxt} ${days} ${dayTxt} ${hours}:${minutes}:${seconds}`);
            } else if (days === 0) {
              $title.text(`${endsTxt} ${todayTxt} ${hours}:${minutes}:${seconds}`);
            } else {
              $title.text(`${endsTxt} ${days} ${daysTxt} ${hours}:${minutes}:${seconds}`);
            }
          }
        }, 1000);
      }
    }

    setVariantsPrice(res) {
      const _this = this;
      $('.js-variant-item').each(function () {
        const sku = $(this).data('sku');
        const $nowPrice = $(this).find('.product-price-count');
        const $oriPrice = $(this).find('.product-ori-price');
        const price = $nowPrice.data('price');
        if (res[sku] && res[sku][0]) {
          const { variant_price4wscode, currency } = res[sku][0];
          $oriPrice.text($nowPrice.text());
          $nowPrice.text(_this.formatPirce(variant_price4wscode, Shopify.country.toLowerCase(), currency));
        }
      });
    }

    getFormatTimes(time) {
      const days = Math.floor(time / (1000 * 60 * 60 * 24));
      const hours = this.formatNum(Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
      const minutes = this.formatNum(Math.floor((time % (1000 * 60 * 60)) / (1000 * 60)));
      const seconds = this.formatNum(Math.floor((time % (1000 * 60)) / 1000));

      return { days, hours, minutes, seconds };
    }

    formatNum(n) {
      return n < 10 ? '0' + n : n;
    }

    setCopyEvent() {
      const _this = this;
      const $copy = this.$el.find('.js-code-copy');
      const copy = $copy.data('copy');
      const copied = $copy.data('copied');
      let lock = false;
      let timer;

      $copy.on('click', function () {
        const code = _this.$el.find('.js-discount-code').text();
        if (lock) return;
        _this.execCoy(code);
        lock = true;
        timer && clearTimeout(timer);
        $(this).text(copied);

        timer = setTimeout(() => {
          lock = false;
          $(this).text(copy);
        }, 3000);
      });
    }

    setFaqEvent() {
      const $faq = $('.js-discount-faq');
      const $faqModel = $('.product-common-model');
      const $faqContent = $('.js-faq-content');

      $faq.on('click', function () {
        $faqModel[0].show($faqContent.html());
      });
    }

    execCoy(text) {
      const input = document.createElement('INPUT');
      input.style.opacity = 0;
      input.style.position = 'absolute';
      input.style.left = '-100000px';
      document.body.appendChild(input);

      input.value = text;
      input.select();
      input.setSelectionRange(0, text.length);
      document.execCommand('copy');
      document.body.removeChild(input);
      return true;
    }

    formatPirce(num, local, currency) {
      if (typeof num !== 'number') {
        num = +num;
      }
      const site = {
        us: 'en-US',
        uk: 'en-GB',
        gb: 'en-GB',
        eu: 'de-DE',
        de: 'de-DE',
        ca: 'en-CA',
        nl: 'de-DE',
        au: 'en-AU',
        lu: 'de-DE',
      };
      const name = site[local] || 'en-GB';
      const res = num
        .toLocaleString(name, {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
        .replace(/\s*/g, '');
      return local === 'ca' ? `CA${res}` : res;
    }
  }

  class ProductFreeGift extends HTMLElement {
    constructor() {
      super();
      this.$el = $('.product-free-gift');
      this.paramsInit();
    }

    paramsInit() {
      const params = this.$el.data('limit');
      let domain = (location.host.split('.')[1] || '') + '.com';
      let exists = false;

      if (domain === 'myshopify.com' || domain === '.com') {
        domain = location.host;
      }
      if (params) {
        const [label, val] = params.split('=');
        exists = this.getCookie(label) === val;
      }
      if (location.search.includes(params) || exists) {
        this.$el.show();
      }
    }

    getCookie(name) {
      let nameEQ = name + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  }

  class ProductOptional extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.paramsInit();
    }

    init() {
      this.$el = $('.product-optional');
      this.$el.find('.js-optionals-item').on('click', function () {
        const actived = $(this).hasClass('actived');
        actived ? $(this).removeClass('actived') : $(this).addClass('actived');
      });
    }

    paramsInit() {
      const params = this.$el.data('limit');
      let domain = (location.host.split('.')[1] || '') + '.com';
      let exists = false;

      if (domain === 'myshopify.com' || domain === '.com') {
        domain = location.host;
      }
      if (params) {
        const [label, val] = params.split('=');
        exists = this.getCookie(label) === val;
      }
      if (location.search.includes(params) || exists) {
        this.$el.show();
      }
    }

    getCookie(name) {
      let nameEQ = name + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
  }

  class ProductCheckoutBar extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.event();
    }

    init() {
      const $product = $('.product');
      this.currency = $product.data('currency');
      this.storefront = $product.data('storefront');
      this.vid = +$product.data('v-id');
      this.product = {
        sku: $product.data('sku'),
        handle: $product.data('handle'),
        title: $product.data('title'),
        price: $product.data('price'),
        type: $product.data('type'),
        vTitle: $product.data('v-title'),
        brand: $product.data('brand'),
        currency: $product.data('currency'),
      };
    }

    event() {
      const _this = this;
      const sku = $('.product').data('sku') || '';
      let postLock = false;

      $('.js-buynow').on('click', function () {
        _this.productBuyNow();
      });

      $('.js-add2cart').on('click', function () {
        _this.productAdd2Cart();
      });

      $('.js-available-remind').on('click', function () {
        const $model = $('.product-common-model');
        $model[0].show($('.js-available-subcribe-content').html());
      });

      $('.js-checkout-bar-more').on('click', function () {
        $(this).hide();
        $(this).parents('.product-checkout-info').removeClass('unactived');
      });

      // available subscribe
      $('body').on('click', '.js-available-subscribe-btn', function () {
        const $model = $('.product-common-model');
        const successInfo = $('.js-success-subcribe-content').html();
        const errorInfo = $model.find('.js-error-info').html();
        const errorEmail = $model.find('.js-error-email').html();
        const errfillEmail = $model.find('.js-error-fill-email').html();
        const $email = $model.find('.js-available-subscribe-input');
        const $policy = $model.find('.js-policy-input');
        const $tips = $model.find('.js-info-tips');
        const email_val = $email.val();
        const email = email_val && email_val.trim();
        const rmaRegExp = {
          email:
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        };

        $tips.html('');

        if (!email) {
          $tips.html(errfillEmail);
          return false;
        }
        if (!rmaRegExp.email.test(email)) {
          $tips.html(errorEmail);
          return false;
        }

        if (postLock) return;

        postLock = true;

        $.ajax({
          headers: Shopify.contentCreator.pastApi.getHeaders(),
          url: `/apps/pp/shopifyservices/product_arrival_notices`,
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
            email,
            sku,
            shop: Shopify.shop,
          }),
          success: function (body) {
            $model[0].show(successInfo, 400);
            $email.val('');
            postLock = false;

            // subscribe
            if ($policy.prop('checked')) {
              Shopify.contentCreator.pastApi.subscribe_emails({
                params: {
                  email,
                  brand: 'eufy',
                },
                fn: (body) => {
                  window.fbq('track', 'CompleteRegistration');
                  $policy.prop('checked', false);

                  const hash = CryptoJS.SHA256(email);
                  const hashEmail = hash.toString(CryptoJS.enc.Hex);

                  window.dataLayer.push({
                    event_parameters: null,
                  });

                  window.dataLayer.push({
                    subscribe_hashed_email: hashEmail,
                  });

                  window.dataLayer.push({
                    event: 'ga4Event',
                    event_name: 'notify_me',
                    event_parameters: {
                      page_group: '',
                      position: 'sticky',
                    },
                  });

                  window.dataLayer.push({
                    event: 'uaEvent',
                    eventCategory: 'subscribe',
                    eventAction: '',
                    eventLabel: 'notify_me',
                    nonInteraction: false,
                  });
                },
              });
            }

            // ga3
            window.dataLayer.push({
              event: 'uaEvent',
              eventCategory: 'notify_me',
              eventAction: sku,
              eventLabel: $policy.prop('checked') ? 'consent' : 'not_consent',
              eventValue: 'undefined',
            });
          },
          error: function (err) {
            postLock = false;
            $tips.html(errorInfo);
          },
        });
      });

      // document.addEventListener('scroll', function () {
      //   const scrollTop = $(window).scrollTop();
      //   const offset = $('#shopify-section-footer-classic-v2')[0].offsetTop - 500;

      //   scrollTop > offset
      //     ? $('.product-checkout-bar').addClass('unact')
      //     : $('.product-checkout-bar').removeClass('unact');
      // });
    }

    productBuyNow({ extend = {} } = {}) {
      const _this = this;
      const code =
        $('.js-group-buynow').data('code') ||
        Shopify.theme.getURLParams('discount') ||
        $('.js-discount-code').text() ||
        '';
      const discount = code.includes('?') ? '' : code;
      const freeGift = this.getFreeGift('buynow', extend);
      const optional = this.getOptional('buynow', extend);

      const line_items = [
        {
          variant_id: _this.vid,
          quantity: 1,
          ...extend,
        },
        ...freeGift,
        ...optional,
      ];

      Shopify.theme.bundleBuynow({
        authorization: _this.storefront,
        checkout: {
          line_items,
          presentment_currency: _this.currency,
          is_upstream_button: true,
          page_type: 'product',
          secret: true,
          discount,
          wallet_name: 'Checkout',
        },
        onSuccess: () => {},
        onError: (err) => $.dialog({ title: err.message, content: err.description, type: 'red' }),
      });

      this.track({
        name: 'begin_checkout',
        action: 'BuyNow',
        group: 'Product Detail Page',
        position: 'Product Detail Page_Checkout',
      });
    }

    productAdd2Cart({ extend = {} } = {}) {
      const _this = this;
      const freeGift = this.getFreeGift('add2cart', extend);
      const optional = this.getOptional('add2cart', extend);
      const line_items = [
        {
          id: _this.vid,
          quantity: 1,
          ...extend,
        },
        ...freeGift,
        ...optional,
      ];

      Shopify.theme.addItemsToCart(line_items, {
        onError: (err) => $.dialog({ title: err.message, content: err.description, type: 'red' }),
      });

      this.track({
        name: 'add_to_cart',
        action: 'Added Product',
        group: 'Product Detail Page',
        position: 'Product Detail Page',
      });
    }

    track({ name, action, group, position }) {
      const { products: optProducts, items: optItems } = this.getOptionalInfo();
      const { products: freeProducts, items: freeItems } = this.getFreeGiftTrackInfo();
      const products = [
        {
          name: this.product.title,
          id: this.product.sku,
          category: '',
          categoryName: this.product.type,
          brand: this.product.brand,
          variant: this.product.vTitle,
          price: this.product.price,
          quantity: 1,
        },
        ...freeProducts,
        ...optProducts,
      ];

      const items = [
        {
          item_id: this.product.sku,
          item_name: this.product.title,
          item_brand: this.product.brand,
          item_category: '',
          item_variant: this.product.vTitle,
          price: this.product.price,
          quantity: 1,
        },
        ...optItems,
        ...freeItems,
      ];

      if (name != 'add_to_cart') {
        window.dataLayer.push({
          event: 'eeEvent',
          eventCategory: 'EnhancedEcommerce',
          eventAction: action,
          eventLabel: this.product.sku,
          nonInteraction: false,
          ecommerce: {
            currencyCode: this.product.currency,
            add: {
              products,
            },
          },
        });
      }

      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: name,
        event_parameters: {
          page_group: group + '_' + this.product.sku,
          position,
          currency: this.product.currency,
          value: this.product.price,
          items,
        },
      });
    }

    getFreeGift(type = 'buynow', extend) {
      const gifts = [];
      const parents = $('.js-free-gift-item').parents('.product-free-gift');

      if (!parents.is(':visible')) return gifts;

      $('.js-free-gift-item').each(function () {
        if (type === 'buynow') {
          gifts.push({
            variant_id: $(this).data('v-id'),
            quantity: $(this).data('count'),
            ...extend,
          });
        } else if (type === 'add2cart') {
          gifts.push({
            id: $(this).data('v-id'),
            quantity: $(this).data('count'),
            ...extend,
          });
        }
      });

      return gifts;
    }

    getFreeGiftTrackInfo() {
      const _this = this;
      const products = [];
      const items = [];
      const parents = $('.js-free-gift-item').parents('.product-free-gift');

      if (!parents.is(':visible')) return { products, items };

      $('.js-free-gift-item').each(function () {
        products.push({
          name: $(this).data('title'),
          id: $(this).data('sku'),
          category: '',
          categoryName: $(this).data('type'),
          brand: _this.product.brand,
          variant: $(this).data('v-title'),
          price: $(this).data('price'),
          quantity: $(this).data('count'),
        });

        items.push({
          item_id: $(this).data('sku'),
          item_name: $(this).data('title'),
          item_brand: _this.product.brand,
          item_category: '',
          item_variant: $(this).data('v-title'),
          price: $(this).data('price'),
          quantity: 1,
        });
      });

      return { products, items };
    }

    getOptional(type = 'buynow', extend) {
      const optional = [];
      const parents = $('.js-optionals-item').parents('.product-optional');

      if (!parents.is(':visible')) return optional;

      $('.js-optionals-item').each(function () {
        if (!$(this).hasClass('actived')) return;
        if (type === 'buynow') {
          optional.push({
            variant_id: $(this).data('v-id'),
            quantity: $(this).data('count'),
            ...extend,
          });
        } else if (type === 'add2cart') {
          optional.push({
            id: $(this).data('v-id'),
            quantity: $(this).data('count'),
            ...extend,
          });
        }
      });

      return optional;
    }

    getOptionalInfo() {
      const _this = this;
      const products = [];
      const items = [];
      const parents = $('.js-optionals-item').parents('.product-optional');

      if (!parents.is(':visible')) return { products, items };

      $('.js-optionals-item').each(function () {
        if (!$(this).hasClass('actived')) return;
        products.push({
          name: $(this).data('title'),
          id: $(this).data('sku'),
          category: '',
          categoryName: $(this).data('type'),
          brand: _this.product.brand,
          variant: $(this).data('v-title'),
          price: $(this).data('price'),
          quantity: $(this).data('count'),
        });

        items.push({
          item_id: $(this).data('sku'),
          item_name: $(this).data('title'),
          item_brand: _this.product.brand,
          item_category: '',
          item_variant: $(this).data('v-title'),
          price: $(this).data('price'),
          quantity: 1,
        });
      });

      return { products, items };
    }
  }

  customElements.define('product-checkout-bar', ProductCheckoutBar);
  customElements.define('product-optional', ProductOptional);
  customElements.define('product-free-gift', ProductFreeGift);
  customElements.define('e-model', EModel);
  customElements.define('product-image', ProductImage);
  customElements.define('product-discount', ProductDiscount);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lost-user-notice"]) return;
  try {
    
  class LostUserNotice extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.closeEvent();
    }

    init() {
      document.addEventListener('serverTimeUpdate', (e) => {
        const localTime = localStorage.getItem('giftcard_lost_user_time');
        const curTime = Shopify.serverTime ? new Date(Shopify.serverTime).getTime() : new Date().getTime();
        const diffTime = 30 * 1 * 1000;
        const isAdd2Cart = localStorage.getItem('add2Cartbehavior');
        const isClose = localStorage.getItem('giftcard_lost_user_close');
        if (isClose) {
          return;
        }

        this.show(localTime, curTime, diffTime);
        const timer = setInterval(() => {
          const localTime = localStorage.getItem('giftcard_lost_user_time');
          this.show(localTime, curTime, diffTime, () => {
            clearInterval(timer);
          });
        }, 1000);
      });
    }

    show(localTime, curTime, diffTime, cb) {
      const $el = $('.hint');

      if (curTime - +localTime > diffTime && isAdd2Cart) {
        // 提示弹窗出现
        $el.removeClass('hidden');
        setTimeout(() => {
          localStorage.setItem('giftcard_lost_user_close', 1);
          $el.addClass('hidden');
        }, 5000);
        cb && cb();
      }
    }

    closeEvent() {
      const $el = $('.hint');

      $el.on('click', '.js-close', () => {
        localStorage.setItem('giftcard_lost_user_close', 1);
        $el.addClass('hidden');
      });
    }
  }

  customElements.define('lost-user-notice', LostUserNotice);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["registrations-model"] && !window.DesignMode) return;
  try {
    
  class RegistrationsModel extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.el = this.querySelector('.registrations-coupons-wrap');
      let registrationsTrack = new RegistrationsTrack();
      this.registrationsTrackInstance = registrationsTrack;
    }

    getPassportUrl() {
      let passport = 'https://';
      if (app.includes('beta')) {
        passport += 'beta.';
      }
      if (app.includes('eufy')) {
        passport += 'passport.eufy.com';
      }
      return passport;
    }

    // 元素是否显示
    isElementVisible(element) {
      let style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    }

    // 加载状态
    handleLoadingStatus($el, type) {
      if (type === 'loading') {
        $el.find('.js-submit').addClass('hidden');
        $el.find('.js-submit-loading').removeClass('hidden');
        $el.closest('model').css('pointer-events', 'none');
      } else {
        $el.find('.js-submit').removeClass('hidden');
        $el.find('.js-submit-loading').addClass('hidden');
        $el.closest('model').css('pointer-events', 'auto');
      }
    }

    // 倒计时
    handleCountDown($itemEl) {
      const expired_at = $itemEl.find('.js-validtime-desc-wrap').attr('data-expired');
      if (!expired_at) return;
      let endTime = new Date(expired_at);
      let timer = setInterval(function () {
        let now = new Date();
        let timestamp = endTime - now;
        if (timestamp <= 0) {
          clearInterval(timer);
          return;
        }
        let daytime = timestamp / (1000 * 60 * 60 * 24);
        let day = Math.floor(daytime);
        let hourtime = (daytime - day) * 24;
        let hour = Math.floor(hourtime);
        let minutetime = (hourtime - hour) * 60;
        let minute = Math.floor(minutetime);
        let secondtime = (minutetime - minute) * 60;
        let second = Math.floor(secondtime);
        day = day > 9 ? day : '0' + day;
        hour = hour > 9 ? hour : '0' + hour;
        minute = minute > 9 ? minute : '0' + minute;
        second = second > 9 ? second : '0' + second;
        $itemEl.find('.js-validtime-hour').text(hour);
        $itemEl.find('.js-validtime-minute').text(minute);
        $itemEl.find('.js-validtime-second').text(second);
      }, 1000);
    }

    // 复制
    execCoy(text) {
      const input = document.createElement('INPUT');
      input.style.opacity = 0;
      input.style.position = 'absolute';
      input.style.left = '-100000px';
      document.body.appendChild(input);

      input.value = text;
      input.select();
      input.setSelectionRange(0, text.length);
      document.execCommand('copy');
      document.body.removeChild(input);
      return true;
    }

    // 处理优惠券数据
    handleCouponData(coupons) {
      const _this = this;
      if (!coupons.length) return;
      const $el = $(`#${this.el.id}`);
      let html = '';
      const countryCode = $('.registrations-main').data('country-code');
      $el.find('.coupons-num').text(` (${coupons.length})`);
      const $item = $el.find('.rsc-coupons-item').eq(0).clone();
      const tagIndex = $item.find('.js-copy-btn').attr('tagIndex');
      const tag = $item.find('.js-copy-btn').attr('tag');
      const $wrapper = $el.find('.rsc-coupons-list');

      coupons.map((item, idx) => {
        const { value_type, value, expired_at, discount_title, code, brief } = item;
        const no_threshold_text = $wrapper.data('no-threshold-text');
        $item.find('.js-coupons-detail-info-code-value').text(code);
        $item.find('.js-threshold-desc').text(brief || no_threshold_text);
        $item.find('.js-copy-btn').attr('tag', `${tag}${+tagIndex + idx}`);

        if (value_type === 'percentage') {
          $item.find('.js-coupons-off-percentage').removeClass('hidden');
          $item.find('.js-coupons-off-fixed').addClass('hidden');
          $item.find('.js-coupons-off-percentage-num').text(Math.abs(Number(value)));
        } else {
          $item.find('.js-coupons-off-fixed').removeClass('hidden');
          $item.find('.js-coupons-off-percentage').addClass('hidden');
          $item.find('.js-coupons-off-fixed-num').text(Math.abs(Number(value)));
          if (['de', 'eu', 'nl'].includes(countryCode)) {
            $item.find('.js-coupons-off-fixed-num').css('order', '-1');
            $item.find('.rsc-coupons-off-fixed-off').css('margin-left', '5px');
          }
        }
        const ends_in_text = $wrapper.data('ends-in-text');
        const time_no_limit_text = $wrapper.data('time-no-limit-text');
        if (expired_at) {
          $item.find('.js-validtime-desc-wrap').attr('data-expired', expired_at).removeClass('hidden');
          $item.find('.js-ends-in-text').text(ends_in_text);
        } else {
          $item.find('.js-ends-in-text').text(time_no_limit_text);
          $item.find('.js-validtime-desc-wrap').addClass('hidden');
        }
        html += `<li class="rsc-coupons-item">${$item.html()}</li>`;
      });
      const note = $wrapper.data('note');
      html += `<li class="rsc-coupons-desc">${note}</li>`;
      $wrapper.html(html);
      document.querySelectorAll('.rsc-coupons-item').forEach((el, idx) => {
        _this.handleCountDown($(el));
      });
      $('.rsc-coupons-item')
        .find('.js-copy-btn')
        .on('click', function (e) {
          const $el = $(this);
          const copyText = $el.data('copy-text');
          const copiedText = $el.data('copied-text');
          const code_number = $el.siblings('.js-coupons-detail-info-code-value').text();
          $(this).text(copiedText);
          _this.execCoy(code_number);
          setTimeout(() => {
            $(this).text(copyText);
          }, 500);
        });
    }

    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    init() {
      const _this = this;
      $('.registrations-model .js-close-btn').on('click', function () {
        const position = $(this).data('position') || '';
        const registrationsPasswordLoginVisible = _this.isElementVisible(
          document.querySelector('.registrations-password-login')
        );
        const rsqlVisible = _this.isElementVisible(document.querySelector('.registrations-quick-login'));
        _this.registrationsTrackInstance.closeTrack({
          position,
          page_group: registrationsPasswordLoginVisible || rsqlVisible ? 'login_pop' : 'reg_sub_pop',
          button_name: 'close',
        });
        $('.registrations-model').addClass('hidden');
        $('.registrations-main').addClass('hidden');
        $('.registrations-quick-login').addClass('hidden');
        $('.registrations-password-login').addClass('hidden');
        $('.registrations-reminder').addClass('hidden');
        $('.registrations-activate').addClass('hidden');
        $('.registrations-subscribe-sms').addClass('hidden');
        if (position) {
          // copoun 弹窗关闭
          const b_auth_token = localStorage.getItem('b_auth_token');
          const passportThemeLoginUrl = Cookies.get('passport-theme-url');
          passportThemeLoginUrl && Cookies.remove('passport-theme-url', { domain, expires: 30 });
          window.location.href = `${_this.getPassportUrl()}/theme-login?app=${
            Shopify.shop.split('.')[0]
          }&t=${b_auth_token}&redirect=${encodeURIComponent(location.href)}`;
        }
      });

      function setCoookie({ auth_token, multipassinfo }) {
        // 设置cookie
        // Cookies.set(`${app}-token`, auth_token, {
        //   domain: shopifyDomain,
        //   expires: 30,
        // });
        Cookies.set(`${app}-info`, auth_token, {
          domain: shopifyDomain,
          expires: 30,
        });
        // Cookies.set(`multipassinfo`, multipassinfo, {
        //   domain: shopifyDomain,
        //   expires: 30,
        // });
      }

      $('.registrations-main button[type="submit"]').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        const countryCode = $('.registrations-main').data('country-code');
        const $el = $(this).parents('.rsm-form');
        const formValues = $el.serializeArray();
        console.log(formValues);

        const emailName = 'registrations[email]';
        const policyName = 'registrations[policy]';
        const subscribeName = 'registrations[subscribe]';
        const email = formValues.filter((v) => v.name === emailName)?.[0].value;
        const policy = formValues.filter((v) => v.name === policyName)?.[0]?.value || false;
        const subscribe = formValues.filter((v) => v.name === subscribeName)?.[0]?.value || false;
        const $emailErrorEl = $el.find('.js-email-error');
        const $checkboxErrorEl = $el.find('.js-checkbox-error');
        const $verifyAccountErrorEl = $el.find('.js-verify-account-error');
        const $rsmInputEl = $el.find('.js-rsm-input');
        let validator = new Validator();
        validator.add(email, 'isNonEmpty', emailName, $emailErrorEl.data('email-required-error'));
        validator.add(email, 'isEmail', emailName, $emailErrorEl.data('is-email-error'));
        validator.add(policy, 'isChecked', policyName, $checkboxErrorEl.data('select-policy-error'));
        let errorMsgObj = validator.validate();

        let timer = null;
        for (const msgObj in errorMsgObj) {
          if (Object.hasOwnProperty.call(errorMsgObj, msgObj)) {
            const msgs = errorMsgObj[msgObj];
            if (msgs && msgs.length) {
              switch (msgObj) {
                case emailName:
                  $emailErrorEl.text(msgs[0]);
                  $rsmInputEl.addClass('input-error');
                  break;
                case policyName:
                  $checkboxErrorEl.text(msgs[0]);
                  break;
                default:
                  break;
              }
              break;
            }
          }
        }

        if (Reflect.ownKeys(errorMsgObj).length) return;

        _this.handleLoadingStatus($el, 'loading');
        const genre = $('.registrations-main .registrations-model-body').data('genre');
        const formData = {
          register_source: window.location.href,
          genre: genre,
          email,
          promise_subscribe: subscribe === 'on' ? true : false,
          single_brand_subscribe: true,
          shopify_domain: Shopify.shop,
        };
        const hostUrl = window.location.host.split('.');
        const shopifyDomain = hostUrl[0].indexOf('beta-') > -1 ? window.location.host : `.${hostUrl[1]}.${hostUrl[2]}`;
        const app = Shopify.shop.split('.')[0];
        if (!window.grecaptcha) return;
        grecaptcha.ready(() => {
          grecaptcha.execute(ShopMetafields.recaptcha, { action: 'register' }).then((xrecaptchaKey) => {
            Shopify.theme.recaptchaCollect({ action: 'register' });
            $.ajax({
              headers: {
                'X-Recaptcha-Token': xrecaptchaKey,
                'X-Recaptcha-Sitekey': ShopMetafields.recaptcha,
              },
              type: 'POST',
              url: '/apps/pp/api/auto-signup',
              dataType: 'json',
              data: JSON.stringify({ email, country_code: Shopify.country.toUpperCase(), app }),
              success: function success(res) {
                const { auth_token, user_id, canAutoSignup, multipassinfo } = res.data;
                setCoookie({ auth_token, multipassinfo });
                if (canAutoSignup) {
                  const b_auth_token = btoa(auth_token);
                  const passportThemeLoginUrl = `${_this.getPassportUrl()}/theme-login?app=${app}&t=${b_auth_token}&redirect=${
                    encodeURIComponent(location.href)
                  }`;
                  // token存储到localStorage
                  localStorage.setItem('b_auth_token', b_auth_token);
                  Cookies.set('passport-theme-url', passportThemeLoginUrl, {
                    domain: shopifyDomain,
                    expires: 30,
                  });
                  console.log('res--:', res);

                  grecaptcha.ready(() => {
                    grecaptcha.execute(ShopMetafields.recaptcha, { action: 'ActivityCreate' }).then((recaptchaKey) => {
                      $.ajax({
                        headers: {
                          ...Shopify.contentCreator.pastApi.getHeaders(),
                          recaptcha: recaptchaKey,
                          'X-Application-Name': `${app}-shopify`,
                          'X-Application-Token': auth_token,
                        },
                        url: '/apps/pp/rainbowbridge/activities',
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(formData),
                        success: async function (activitiesRes) {
                          const { coupons = [] } = activitiesRes;
                          const $couponEl = $('.registrations-coupons');
                          if (!coupons.length) return;

                          // $couponEl.removeClass("hidden");
                          console.log('activitiesRes:', activitiesRes);

                          $('.registrations-main').addClass('hidden');
                          if (countryCode === 'us') {
                            $('.registrations-subscribe-sms').removeClass('hidden');
                            $('.registrations-subscribe-sms').attr('data-register-email', email);
                          } else {
                            $('.registrations-coupons').removeClass('hidden');
                          }

                          await _this.registrationsTrackInstance.registrationsTrack({
                            action: 'success',
                            subscribe: subscribe === 'on' ? 1 : 0,
                            email,
                            deals_type: genre,
                          });
                          $('.registrations-model .js-close-btn').attr('data-position', 'success');

                          _this.handleCouponData(coupons, $couponEl);

                          _this.handleLoadingStatus($el, 'unloading');
                        },
                        error: function (error) {
                          _this.handleLoadingStatus($el, 'unloading');
                          console.log('error:---', error);
                        },
                      });
                    });
                  });
                } else {
                  // 存在资产不能登录
                  $verifyAccountErrorEl.removeClass('hidden');
                  _this.handleLoadingStatus($el, 'unloading');
                }
              },
              error: (err) => {
                console.log(err, 'errr-');
                if (err.status === 422) {
                  // 邮箱已注册
                  $('.registrations-main').addClass('hidden');
                  $('.registrations-quick-login').removeClass('hidden');
                  $('.registrations-quick-login .rsql-back').show();
                  $('.registrations-quick-login .js-rsql-input').val(email);
                } else {
                  // start_ai_generated
                  // 服务器错误
                  const $infoServerErrorEl = $el.find('.js-info-server-error');
                  $infoServerErrorEl.removeClass('hidden');
                  // end_ai_generated
                }
                _this.handleLoadingStatus($el, 'unloading');
              },
            });
          });
        });
      });

      $('.registrations-password-login .form-item-icon-wrap').on('click', function (e) {
        const $input = $(this).siblings('input[name="passwordLogin[password]"]');
        const $showIconEl = $(this).find('.form-item-icon-show');
        const $hideIconEl = $(this).find('.form-item-icon-hide');
        if ($input.attr('type') === 'password') {
          $input.attr('type', 'text');
          $showIconEl.show();
          $hideIconEl.hide();
        } else {
          $input.attr('type', 'password');
          $showIconEl.hide();
          $hideIconEl.show();
        }
      });

      $('.registrations-model .rsm-login a').on('click', function (e) {
        $('.registrations-main').addClass('hidden');
        $('.registrations-quick-login').removeClass('hidden');
      });

      $('.registrations-model .js-rsm-input').on('focus', function (e) {
        const $emailErrorEl = $('.registrations-main .js-email-error');
        const $infoServerErrorEl = $('.registrations-main .js-info-server-error');
        $infoServerErrorEl.addClass('hidden');
        const emailError = $emailErrorEl.text();
        if (emailError) {
          emailError && $emailErrorEl.text('');
          $(this).removeClass('input-error');
        }
      });

      $('.registrations-model .js-policy-checkbox').on('change', function (e) {
        const $checkboxErrorEl = $('.registrations-main .js-checkbox-error');
        // start_ai_generated
        if ($(this).is(':checked')) {
          $checkboxErrorEl.text('');
        }
        // end_ai_generated
      });
    }
  }
  customElements.define('registrations-model', RegistrationsModel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["url-list"] && !window.DesignMode) return;
  try {
    
  class LinkList extends HTMLElement {
    constructor() {
      super();
      this.event();
    }

    event() {
      $('.js-links-learn-more').on('click', function () {
        $(this).hide();
        $(this).siblings('.link-ul').find('.link-list-item').removeClass('hidden');
      });
    }
  }
  customElements.define('link-list', LinkList);

  } catch(e) { console.error(e); }
})();
      })();
